var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount_no_decimals}} " + (window.Shopify.currency?.active || "EUR");
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
    ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
    -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class InfiniteScroll {
  constructor(container, restoreState){
    this.containerSelector = container;
    this.collectionHolder = document.querySelector('#mainCollectionHolder');
    this.dataScroll = this.collectionHolder.getAttribute('data-scroll');

    this.treshold = 650;

    if (restoreState == true && sessionStorage.getItem('pageState')){
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initialize();
    }
  }

  initialize(){
    if(this.dataScroll == 'true'){
      this.handleScrollListener = this.handleScroll.bind(this);
      document.addEventListener('scroll', this.handleScrollListener); 
    } else {
      this.handleClickListener = this.handleClick.bind(this);
      this.loadMoreButton = document.querySelector('#infiniteScroll');
      this.loadMoreButton?.addEventListener("click", this.handleClickListener);
    }
  }

  handleClick(e) {
    e.preventDefault();

    this.paginationElement = document.querySelector('#infiniteScroll');
    if (!this.paginationElement) return;

    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    if (!this.nextPageLinkElement) return;

    if (this.paginationElement.classList.contains('is-loading')) return;
    this.paginationElement.classList.add('is-loading');
    this.paginationElement.setAttribute('aria-busy', 'true');

    const nextPageUrl = this.nextPageLinkElement.href;

    this.destroy();

    const promises = this.generateFetchPromises(nextPageUrl);
    this.renderData(promises);
  }


  handleScroll() {
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (!this.paginationElement) return;

    const top = this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom = this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector('a');

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
    
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  destroy() {    
    // Remove the event listener when the instance is no longer needed
    if(this.dataScroll == 'true'){
      document.removeEventListener('scroll', this.handleScrollListener); 
    } else {
      this.loadMoreButton?.removeEventListener("click", this.handleClickListener);
    }
  }

    generateFetchPromises(nextPageUrl) {
      const promises = [];

      if(nextPageUrl == false){
        const hasSearchParameters = window.location.search.length > 0;
        const limit = parseInt(sessionStorage.getItem('pageState'));
        for (let i = 2; i <= limit; i++) {
          let url;
       

          // Build the URL based on the condition
          if (hasSearchParameters) {
            url = `${window.location.href}&page=${i}`;
          } else {
            url = `${window.location.href}?page=${i}`;
          }

          promises.push(fetch(url, {
            credentials: "same-origin",
            method: "GET",
          }));
        }
      } else {
        const url = `${nextPageUrl}`;
  
        promises.push(fetch(url, {
          credentials: "same-origin",
          method: "GET",
        }));
      }

      return promises;
    }
  

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(responses.map(response => response.text()));
      let isLastPromise = false;

      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error('Error fetching or parsing data:', error);
    }
  }


  appendContent(content, lastPromise, restoreContent){
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const contentToAdd = doc.querySelector(this.containerSelector);
    
    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector('#infiniteScroll');

    if (this.paginationElement){
      this.paginationElement.remove();
    }
    this.mainContainer.insertAdjacentHTML('beforeend', contentToAdd.innerHTML);
    this.paginationElement = document.querySelector('#infiniteScroll');
    if(lastPromise){
      this.initialize();
    }

    if(lastPromise && restoreContent){
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );
 
  }
  restoreScroll() {
    const selector = `${this.containerSelector} [data-id='${sessionStorage.getItem('pageStateProduct')}']`;
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth', // You can use 'auto' for instant scrolling
        block: 'start',     // You can use 'center' or 'end' for different alignments
      });
    }
  }
}
class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    

    window.addEventListener("resize", this.calculateMaxHeightListener);
    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");
    this.maxHeight()
    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }

  maxHeight() {
   
    this.activeModal.style.height = window.innerHeight + 'px';

  }

  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }

  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
    removeTrapFocus();
  }
}

class CustomImageZoom {
  constructor(element, images) {
    this.element = element;
    this.images = images;

    this.delegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
    this.initImageZoom();
  }

  bindEvents() {
    this.delegate.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.toggleImageZoom.bind(this)
    );

    this.delegate.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.toggleImageZoom.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-product-zoom"]',
      this.closeImageZoom.bind(this)
    );
  }

  initImageZoom() {
    this.wrapper = document.createElement("div");
    this.wrapper.style.display = "none";
    this.wrapper.classList.add("image-zoom__main");
    this.wrapper.setAttribute("aria-hidden", true);

    const button = document.createElement("button");
    button.classList.add("image-zoom__close");
    button.setAttribute("data-action", "close-product-zoom");
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M13.0605 12L18 7.0605L16.9395 6L12 10.9395L7.0605 6L6 7.0605L10.9395 12L6 16.9395L7.0605 18L12 13.0605L16.9395 18L18 16.9395L13.0605 12Z" fill="black"/>
      </svg>`;

    this.wrapper.appendChild(button);

    this.images.forEach(img => {
      this.wrapper.appendChild(img.cloneNode());
    })

    document.body.appendChild(this.wrapper);
  }

  toggleImageZoom() {
    const target = event.target.closest("img") || event.target.closest(".swiper-slide")?.querySelector("img");
    const hidden = this.wrapper.getAttribute("aria-hidden") === "true";

    if (hidden) {
      bodyScrollLock.disableBodyScroll(this.wrapper);
      this.wrapper.style.display = "flex";
      window.requestAnimationFrame(() => { this.wrapper.setAttribute("aria-hidden", "false") });

      this.scrollToTarget(target);

    } else {
      bodyScrollLock.clearAllBodyScrollLocks();
      this.wrapper.setAttribute("aria-hidden", "true");
      setTimeout(() => { this.wrapper.style.display = "none" }, 300);
    }
  }

  closeImageZoom() {
    const wrapper = event.target.closest('.image-zoom__main[aria-hidden="false"]');
    if (!wrapper) return;

    bodyScrollLock.clearAllBodyScrollLocks(wrapper);
    wrapper.setAttribute("aria-hidden", "true");
    setTimeout(() => { wrapper.style.display = "none" }, 300);
  }

  scrollToTarget(target) {
    if (!target) return;
    
    const allImages = this.wrapper.querySelectorAll("img");
    allImages.forEach(img => {
      if (img.dataset.originalSrc === target.dataset.originalSrc) {
        img.scrollIntoView({
          behavior: "auto",
          block: "center",
        });
      }
    })
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index_currentSlide)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint("pocket")) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("ProductSliderCell--Zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });


    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position")
    );

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {

    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
    
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    let responsive = new Responsive();
    this.breakpoint = responsive.getCurrentBreakpoint();
   
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
 
    this.bindEvents();
    this.initSelectbox();
    
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);

   
    if ((this.breakpoint == "phone" || this.breakpoint == "tablet")) {
      this.domDelegate.on(
        "click",
        "[data-action=toggle-selectbox-pdp]",
        this.toggleDropdown.bind(this)
      );
    }

    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
   
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on('click', '[data-action="click-subscribe-dropdown"]', this.openSubscribeDropdown.bind(this));

    if ((this.breakpoint === "desk" || this.breakpoint === "lap")) {
     this.domDelegate.on(
      "mouseover",
      "product-component [data-action=toggle-selectbox-pdp]",
      this.openOnHover.bind(this)
    );
     }

    if ((this.breakpoint === "desk" || this.breakpoint === "lap")) {

    this.domDelegate.on(
      "mouseleave",
      "product-component .RevolutionSelectbox",
      this.closeOnLeave.bind(this)
    );
    }
 


    this.domDelegate.on(
      "click",
      "[data-action=selectbox-notify-me]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  disconnectedCallback() {
    this.domDelegate.destroy();
    this.delegateBody.destroy();
  }

  openSubscribeDropdown() {
    const drawer = event.target.closest(".subscription-dropdown__drawer");

    const closeDrawerButton = drawer.querySelector(".subscription-dropdown__drawer-close");
    closeDrawerButton?.click();

    const subscribeDropdown = document.querySelector('product-component [data-action="toggle-sub-dropdown"][aria-expanded="false"]');    
    subscribeDropdown?.click();
    
  }

  closeOnLeave(event, target){

    target = this.element.querySelector(".RevolutionSelectbox--Button[aria-expanded='true']");
    this.closeDropdown(target);
  }
  openOnHover(event, target) {
    

    event.preventDefault();
    const timeoutId = setTimeout(() => {
    this.openDropdown(target);
    }, 100);

    target.addEventListener('mouseleave', () => {
      clearTimeout(timeoutId);
    });

  }
  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    
    const innerContent = event.target.innerHTML;

    // add \\ before ( as it will trigger js error if its not typed as \\( in query selector 
    const selector = `#${selectboxID.replace(/([()])/g, "\\$1")}`;
    var selEl = this.element.querySelector(selector);
    
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      
      selEl.dispatchEvent(new Event("change"));
      if (selEl.id == "select-location-country") {
        const selectboxItems = this.element.querySelectorAll(
          ".RevolutionSelectbox--ItemCustom"
        );
        const selectedItem = this.element.querySelector(
          `.RevolutionSelectbox--ItemCustom[data-value="${value}"]`
        );

        selectboxItems.forEach((item) =>
          item.setAttribute("selected", "false")
        );
        if (selectedItem) selectedItem.setAttribute("selected", "selected");
      }
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }

    const title = this.mainButton.querySelector(".RevolutionSelectbox--Title");
    if (title.dataset.optionName) {
      title.innerHTML = innerContent;
      title.firstElementChild.classList.add("RevolutionSelectbox--TitleSpan");
      title.firstElementChild.innerText = `${title.dataset.optionName}, ${title.firstElementChild.innerText}`;
      title.parentElement.setAttribute('checked', true);
    } else {
      title.innerHTML = innerContent;
      title.parentElement.setAttribute('checked', true);
    }

    if (this.element.classList.contains("dropdownSelector")) {
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        ? this.element
            .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
            .removeAttribute("disabled")
        : null;
      event.target.setAttribute("disabled", "true");
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
   
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries  && !event.target.classList.contains("mainProduct--variantNotSelected") ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
     
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
        '[selected="selected"]'
      ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
      
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {

    event.preventDefault();
   
    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
 
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      trapFocus(this.mainDropdown);
      if (
        document.querySelector("#mainMenu").getAttribute("aria-expanded") ===
        "true"
      ) {
        document.querySelector(".Drawer--Wrapper").style.overflow = "visible";
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );


    target.setAttribute("aria-expanded", "true");
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    contentElement.setAttribute("aria-hidden", "false");

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
   
    if(!target) return;
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );
   
      const menuDrawer = document.querySelector("#mainMenu");
      if (menuDrawer.getAttribute("aria-expanded") == "true") {
        document.querySelector(".Drawer--Wrapper").style.overflow = "auto";
        document.body.classList.remove("scrollLock");

       /*  bodyScrollLock.enableBodyScroll(closestDropdown.querySelector('[data-scrollable]')); */
      } else {

        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }
      
      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element, oneToWatch, secondToWatch) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    
    this.bindEvents();

    this.oneToWatch = oneToWatch;
    this.secondToWatch = secondToWatch;
    this.giftWrappBtns = document.querySelectorAll(".CartFooter--giftWrapp");
    this.swimBagBtns = document.querySelectorAll('.CartFooter--swimbagBtn');
  }

  bindEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="add-to-cart"]',
      this.addToCart.bind(this)
    );
  }

  async addToCart(event) {
    event.preventDefault();
    const addToCartButton = event.target;
    this.pageLoader.style.width = "100%";

    addToCartButton.classList.add("adding-to-cart");
    addToCartButton.setAttribute("disabled", "disabled");

    const formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");

    const formHelper = new Form();
    const serialized = formHelper.serialize(formElement);

    const subInput = formElement.querySelector("input#selling_plan");
    if (serialized.selling_plan === "" && subInput.value !== "") serialized.selling_plan = subInput.value;
    

    try {
        const response = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
            body: JSON.stringify(serialized),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        });

        if (response.ok) {
            if (window.location.href.includes("cart")) {
                location.reload();
                return;
            }

            addToCartButton.removeAttribute("disabled");
            this.element.dispatchEvent(
                new CustomEvent("product:added", {
                    bubbles: true,
                    detail: {
                        variant: serialized.id,
                        quantity: serialized.quantity,
                    },
                })
            );
        } else {
            const content = await response.json();
            return this.showError(content.description, addToCartButton);
        }

        const addedItem = await response.json();

        if (this.oneToWatch && addedItem.variant_id === this.oneToWatch) {
            localStorage.setItem("giftWrap", "added");
            setTimeout(() => {
                this.giftWrappBtns.forEach((btn) => (btn.style.display = "none"));
            }, 150);
        }

        if (this.secondToWatch && addedItem.variant_id === this.secondToWatch) {
            localStorage.setItem("swimBag", "added");
            setTimeout(() => {
                this.swimBagBtns.forEach((btn) => (btn.style.display = "none"));
            }, 150);
        }
    } catch (error) {
        console.error("Error adding to cart:", error);
        this.showError("An unexpected error occurred. Please try again.", addToCartButton);
    } finally {
        this.pageLoader.style.left = "unset";
        this.pageLoader.style.right = "0px";
        this.pageLoader.style.width = "0%";
       
        setTimeout(() => {
          this.pageLoader.style.left = "0px";
          this.pageLoader.style.right = "unset";

          addToCartButton.classList.remove("adding-to-cart");
          addToCartButton.classList.add("added-to-cart");

          setTimeout(() => {
            addToCartButton.classList.remove("added-to-cart"); 
          }, 1000); 

        }, 500); 

    }
  }

  showError(message, addToCartButton) {
      if (this.element.querySelector(".ProductForm--Error")) {
          const errorElement = this.element.querySelector(".ProductForm--Error");
          //errorElement.scrollIntoView();
          errorElement.classList.add("visible");
          setTimeout(() => errorElement.classList.remove("visible"), 2500);
      } else {
          const errorMessageElement = document.createElement("span");
          errorMessageElement.className = "u-p4 accent";
          errorMessageElement.innerHTML = message;
          addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
          setTimeout(() => errorMessageElement.remove(), 2500);
      }
      addToCartButton.removeAttribute("disabled");
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled:not(.not_desktop), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  if (first.dataset.toggleId === "FiltersDrawer") {
    first = elements[2];
  }

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;

    switch (this.breakpoint) {
      case "lap-and-up":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem) {
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    DropdownButton.setAttribute("aria-expanded", "true");

    new RevolutionAnimation(DropdownContent, "true").slideDown();

    DropdownContent.querySelectorAll('a, button, input, textarea, select')
    .forEach(el => el.setAttribute('tabindex', '0'));

  }

  closeDropdown(elem) {
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", "false");

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        DropdownContent.setAttribute("aria-hidden", "true");
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    

    this.element?this.element.addEventListener("transitionend", transitionEnded):null;

    DropdownContent.querySelectorAll('a, button, input, textarea, select')
    .forEach(el => el.setAttribute('tabindex', '-1'));
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      // If dropdown is open, close it
      this.closeDropdown(mainDropdown, target);
    } else {
      // If dropdown is closed, open it
      this.openDropdown(mainDropdown, target);
    }
  }
}

new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);

    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("reachEnd", () => {
      this.element.classList.add('swiper-atEnd');
    });

    this.swiperElement.on("fromEdge", () => {

      this.element.classList.remove('swiper-atEnd');
    });

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.headerTransparent = document.body.querySelector('#header').classList.contains('Header--Transparent')?true:false;
    

    if (this.element.getAttribute("drawer-name") === "dopdownMob-DrawerDesk") {
      this.pageOverlayElement = document.querySelector(".pageOverlayPDP");
    } else if (this.element.getAttribute("id") === "sizeGuide") {
      this.pageOverlayElement = document.querySelector(
        ".pageOverlaySizeGuidePDP"
      );
    }
    else if(this.element.getAttribute("id") === "subscription-drawer"){
     
      this.pageOverlayElement = document.querySelector(
        ".pageOverlaySubscriptionPDP"
      );
    } else if(this.element.getAttribute("id") === "subscription-info"){
     
      this.pageOverlayElement = document.querySelector(
        ".pageOverlaySubscriptionPDP"
      ); 
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;

    this.pdpInfo = document.querySelector('.ProductInfo--Wrapper');

    this.bindEvents();
  }

  bindEvents() {


    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this.delegateBody.on(
      "keydown",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      (event, target) => {
        if (event.key === "Enter" || event.key === "Escape" || event.key === " ") {
          this.toggleDrawer(event, target);
        }
      }
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-drawers"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawers.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    

    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    
    if (
      this.element.classList.contains('mainProductDropdownContent--wrapper') &&
      (this.breakpoint === 'tablet' || this.breakpoint === 'phone')
    ) {
      return;
    }


    this.element.style.height = window.innerHeight + 'px';
  
    const headerHeight = this.element.querySelector('.Drawer--Header')
      ? this.element.querySelector('.Drawer--Header').offsetHeight
      : 0;
  
    const setDrawerHeight = (selector, offset = 24) => {
      const drawerElement = this.element.querySelector(selector);
      if (drawerElement) {
        drawerElement.style.height = window.innerHeight - headerHeight - offset + 'px';
      }
    };
  
    setDrawerHeight('.DropdownDrawerPDP--ContentPDP .main-productPDPDrawerID.desktop');
    setDrawerHeight('.subscriptionDrawerContentInner', 24 + (this.element.querySelector('.subsDrawerContentInner--btn') ? this.element.querySelector('.subsDrawerContentInner--btn').offsetHeight + 2 : 0));
  
    if (this.element.id === 'cart') {
     
      requestAnimationFrame(()=>{
        const footer = this.element.querySelector('.CartDrawer--Footer');
        const consent = document.querySelector('#shopify-buyer-consent');
        const headerEl = this.element.querySelector('.CartHeader');
        const itemWrapper = this.element.querySelector('.CartItems--Wrapper');

        // if(consent){
        //   consent.style.display = 'block';
        // }

        const footerHeight = footer ? footer.offsetHeight : 0;
        const consentHeight = consent ? consent.offsetHeight : 0;
        const headerHeight = headerEl ? headerEl.offsetHeight : 0;

        if (itemWrapper) {
          itemWrapper.style.height = `${window.innerHeight - headerHeight - footerHeight - consentHeight}px`;
         //console.log(window.innerHeight, footerHeight, consentHeight, headerHeight)
        }
      })
    }
  }

  toggleDrawers(){
    let drawers = document.querySelectorAll('.SidebarDrawer--Wrapper');
    let drawerElement = document.querySelector('.mainMenu--drawer');
    drawerElement.setAttribute('aria-expanded', false);
    drawers.forEach((drawer)=>{
      drawer.setAttribute('aria-hidden', true);
    })
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.isOpen = false;
    this.onClose();
  }

  toggleDrawer() {

    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();

  }

  openDrawer() {

    if (this.isOpen) {
      return;
    }

    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

      document.cookie = 'dynamic_checkout_shown_on_cart' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );
     
    if(this.element.classList.contains('mainProduct--sizeGuideDrawerContentWrapper') || this.element.classList.contains('DropdownDrawerPDP--ContentPDP') || this.element.classList.contains('mainProduct--subDrawerWrapper')){
      this.pdpInfo?this.pdpInfo.style.zIndex = 19:null; 
    }

    this.maxHeight();
    if (this.element.getAttribute("id") == "Drawer") {
      document.querySelector(".Drawer--Close").style.display = "block";
    }

    this.element.setAttribute("aria-expanded", "true");

    if (this.element.id == "FiltersDrawer" || this.element.id == "sortby") {
      document
        .querySelector(`[data-toggle-id='${this.element.id}']`)
        .classList.add("clicked");
 
    }

    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      if (this.element.id != "FiltersDrawer" && this.element.id != "sortby") {
        this.pageOverlayElement.classList.add("is-visible");
      }
      if (this.element.id == "FiltersDrawer")
        if (document.querySelector(".CollectionGrid--CloseFilters")) {
          document.querySelector(
            ".CollectionGrid--CloseFilters"
          ).style.display = "block";
        }

        if (document.querySelector(".CollectionGrid--GridChange")) {
          document.querySelector(
            ".CollectionGrid--GridChange"
          ).style.pointerEvents = "none";
        }
    } else {
      if (this.element.id == 'accountDrawer'){
        if (new Responsive().matchesBreakpoint('lap-and-up')){
          this.pageOverlayElement.classList.add("is-visible");
          this.pageOverlayElement.addEventListener("click", this._closeListener);
        } else if(this.headerTransparent){
          document.body.querySelector('#header').classList.remove('Header--Transparent'); 
        }
      } else {
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this._closeListener);
      }

    }



    this.pageOverlayElement.addEventListener("click", this._closeListener);
    const scrollable = this.element.querySelector("[data-scrollable]");

    bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);

    const focus = this.element.querySelector(".FilterDrawer") || this.element;

    this.isOpen = true;
    setTimeout(() => {
      trapFocus(focus);
    }, 400);
    this.onOpen();

    this.element.querySelectorAll('a, button, input, textarea, select')
    .forEach(el => el.setAttribute('tabindex', '0'));

    return false;
  }

  closeDrawer(event) {
    if(event && event.target.closest('.giftwrappDrawer')){
      document.querySelector(".header-CartBag[data-toggle-id='cart']").click();
      return;
     }

    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      if (this.element.id == "FiltersDrawer")
        if (document.querySelector(".CollectionGrid--CloseFilters")) {
          document.querySelector(
            ".CollectionGrid--CloseFilters"
          ).style.display = "none";
        }
        if (document.querySelector(".CollectionGrid--GridChange")) {
          document.querySelector(
            ".CollectionGrid--GridChange"
          ).style.pointerEvents = "all";
        }
    }


    const focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.enableBodyScroll(focus);
    if (this.element.getAttribute("id") == "cart" || this.element.getAttribute("id") == "accountDrawer") {
      if(this.headerTransparent)
          document.body.querySelector('#header').classList.add('Header--Transparent'); 
      
    }
    this.element.setAttribute("aria-expanded", "false");

    if (this.element.id == "FiltersDrawer" || this.element.id == "sortby") {
      document
        .querySelector(`[data-toggle-id='${this.element.id}']`)
        .classList.remove("clicked");
        bodyScrollLock.clearAllBodyScrollLocks();
    }
    if(this.element.id == 'cart' ){
    bodyScrollLock.clearAllBodyScrollLocks();
    }

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
   
    this.isOpen = false;
    this.onClose();
    this.pdpInfo?this.pdpInfo.style.zIndex = 2:null; 

    this.element.querySelectorAll('a, button, input, textarea, select')
    .forEach(el => el.setAttribute('tabindex', '-1'));
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer += i;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer += i;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {

    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: "elementFromTop",
          elementFromBottom: "elementFromBottom",
          elementFromRight: "elementFromRight",
          elementFromLeft: "elementFromLeft",
          elementFromLeftBig: "elementFromLeftBig",
          elementFromRightBig: "elementFromRightBig",
          elementScaleIn: "elementScaleIn",
          elementScaleOut: "elementScaleOut",
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.25 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.delegateBody = new Delegate(document.body);
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.delegateBody.on("price:change", this.toggleAddButton.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton(e) {
    let quantity = "";
    const addButton = document.querySelectorAll(".ATC--TrackQuantity"),
      addButtonInner = document.querySelectorAll(
        ".ATC--TrackQuantity .SelfAlign"
      );
    var quantityEl = this.element.querySelector(
      ".QuantitySelector__ProductQuantity"
    );

    if (e) {
      if (e.detail.eventName == "subs") {
        quantity = 1;
        quantityEl.value = 1;
      }
    } else if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="Svg Svg--shopping_cart mr-m" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.31 5.19547C25.1687 5.02127 24.9568 4.91946 24.7325 4.91797H9.11751L9.60501 6.41797H23.75L21.7475 15.418H10.4975L7.07001 4.56547C6.99476 4.33174 6.80986 4.14965 6.57501 4.07797L3.50001 3.13297C3.24278 3.05393 2.96292 3.11812 2.76584 3.30137C2.56877 3.48461 2.48443 3.75907 2.54459 4.02137C2.60476 4.28366 2.80028 4.49393 3.05751 4.57297L5.75001 5.39797L9.19251 16.273L7.96251 17.278L7.86501 17.3755C7.2374 18.0987 7.21221 19.1659 7.80501 19.918C8.21952 20.4221 8.84817 20.7002 9.50001 20.668H22.0175C22.4317 20.668 22.7675 20.3322 22.7675 19.918C22.7675 19.5038 22.4317 19.168 22.0175 19.168H9.38001C9.20436 19.162 9.0446 19.0646 8.95873 18.9113C8.87286 18.7579 8.87334 18.5709 8.96001 18.418L10.7675 16.918H22.3475C22.705 16.9267 23.0189 16.6818 23.0975 16.333L25.475 5.83297C25.5212 5.6064 25.4603 5.37117 25.31 5.19547ZM20.75 25.168C21.682 25.168 22.4375 24.4125 22.4375 23.4805C22.4375 22.5485 21.682 21.793 20.75 21.793C19.818 21.793 19.0625 22.5485 19.0625 23.4805C19.0625 24.4125 19.818 25.168 20.75 25.168ZM12.185 23.4805C12.185 24.4125 11.4295 25.168 10.4975 25.168C9.56553 25.168 8.81001 24.4125 8.81001 23.4805C8.81001 22.5485 9.56553 21.793 10.4975 21.793C11.4295 21.793 12.185 22.5485 12.185 23.4805Z" fill="#121212"></path></svg>';
    } else {
      var buySvg = "";
    }


    if (!addButton || Array.from(addButton).some(element => element.getAttribute("disabled") === "disabled")) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.forEach((btn) => {
      btn.removeAttribute("disabled");
      btn.classList.remove("ProductCard--Sold__Out");
    });
    quickBuy.classList.remove('disabled');
    if (window.variantInfo.show_price) {
      let price;

      if (e) {
        if (e.detail) price = e.detail.price;
      } else {
        price = Shopify.formatMoney(
          this.options["price"] * quantity,
          window.theme.moneyFormat
        );
      }

      if (price.indexOf(".00") !== -1) price = price.replace(".00", "");

      var priceElement = " - <span class='u-pb1 ml-s  mainProductBtn--price'>" + price + "</span>";
    } else {
      var priceElement = "";
    }

    if (new Responsive().matchesBreakpoint("tablet-and-up")) {
      addButtonInner.forEach(
        (btn) =>
          (btn.innerHTML =
            buySvg + window.variantStrings.addToCart + priceElement)
      );
    } else {
      addButtonInner.forEach(
        (btn) => (btn.innerHTML = buySvg + window.variantStrings.addToCart)
      );
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.counter = this.element.querySelector(".component-countDown");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);
    let nOfDays = this.options.countdownDays;
    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
      //  nOfDays = 2;
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    const todaysDay = dateNow.getDay();

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    if (this.options["countdownType"] == "reccuring") {
      if (todaysDay === 1) {
        textDays = nOfDays;
      } else if (todaysDay === 0) {
        textDays = 0;
      } else {
        textDays = nOfDays - todaysDay;
        if (textDays < 0) {
          const mDays = todaysDay % nOfDays;
          textDays = nOfDays - mDays;
        }
      }
    }



    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0 && nOfDays > 1) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

let handleExpress = false;

class CartDrawer extends HTMLElement {
  static cart;

  constructor() {
    super();
    this.element = this;

    this.getCart();
    this.initVariables();
    this.bindEvents();
    this.getBagQuantitys();
    this.setBagStates();

    this.cartPage = document.querySelector('#cart-checkout');

    if (this.cartPage) {
      setTimeout(() => {
        this.initInformation();
      }, 500);
    }

        
    if(handleExpress == false) {
      this.handleExpressButtons();
      handleExpress = true;
    }

  }

  initInformation() {
    let consent = document.querySelector('#shopify-buyer-consent');
    console.log(consent);

    if(consent && !consent.classList.contains('hidden')){
      let parentElement =
        this.element.querySelector('.CartCheckout--Items') ||
        this.element.querySelector('.CartDrawer');

      

        if(this.cartPage && new Responsive().matchesBreakpoint('lap-and-up')){
          let checkoutSubmit =
            this.element.querySelector('.CartCheckout--submit') ||
            this.element.querySelector('.cart__drawer--footer__wrapper');
          checkoutSubmit.after(consent);
        }else{
          let checkoutSubmit =
            this.element.querySelector('.cart__checkout--submit-wrapper') ||
            this.element.querySelector('.cart__drawer--footer__wrapper');
          parentElement.insertBefore(consent, checkoutSubmit);
        }
        
    }
  }


  async getCart() {
      try {
          const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });
        
          const data = await response.json();
          CartDrawer.cart = data;
    
      } catch (error) {
          console.log('Fetch Error:', error);
      }
  }

  initVariables() {
    this.delegateElement = new Delegate(this.element);
    this.Drawer = new Drawer(this.element);    
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    new AddToCart(this.element);

    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.recommendationsLoaded = false;
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");

    this.oneToWatch = document.querySelector("#giftwrappDrawer input[data-productid]");
    if (this.oneToWatch) this.oneToWatch = this.oneToWatch.value;

    this.secondToWatch = document.querySelector("#swimbagDrawer input[data-productid]");
    if (this.secondToWatch) this.secondToWatch = this.secondToWatch.value;

    this.renderMsg();
  }

  bindEvents() {
    addEventListener("DOMContentLoaded", () => {      
      this.loadRecommendations();
    });

    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  // gets amont of gift and regular products
  getBagQuantitys() {
    const giftBag = this.element.querySelector("[data-gift-bag-item]");
    this.giftBagAmount = giftBag ? Number(giftBag.querySelector("input.QuantitySelector__CurrentQuantity").value) : 0;

    const swimBag = this.element.querySelector("[data-bag-item]");
    this.swimBagAmount = swimBag ? Number(swimBag.querySelector("input.QuantitySelector__CurrentQuantity").value) : 0;

    const normalProducts = this.element.querySelectorAll(".cartItem:not([data-gift-bag-item]):not([data-bag-item])");
    this.normalProductAmount = 0;

    normalProducts.forEach(item => {
      this.normalProductAmount += Number(item.querySelector("input.QuantitySelector__CurrentQuantity").value);
    })

    const swimProduct = this.element.querySelectorAll(".cartItem[data-swim-item]");
    this.swimProductAmount = 0;

    swimProduct.forEach(item => {
      this.swimProductAmount += Number(item.querySelector("input.QuantitySelector__CurrentQuantity").value);
    })
  }

  setBagStates() {
    ///// gift bag
    // toggle add gift bag +
    const enableGiftBagQuantityButton = this.giftBagAmount >= this.normalProductAmount ? false : true;
    const giftBag = this.element.querySelector("[data-gift-bag-item]");
    this.toggleItemsQuantityButton(giftBag, enableGiftBagQuantityButton);

    ///// swim bag
    // toggle swim bag + 
    const enableSwimBagQuantityButton = this.swimBagAmount >= this.swimProductAmount ? false : true;
    const swimBag = this.element.querySelector("[data-bag-item]");
    this.toggleItemsQuantityButton(swimBag, enableSwimBagQuantityButton);
  }

  toggleItemsQuantityButton(item, enable) {
    if (!item) return;

    if (enable) {
      item.querySelector(".QuantitySelector__PlusButton").classList.remove("disabled");
    } else {
      item.querySelector(".QuantitySelector__PlusButton").classList.add("disabled");
      item.querySelector(".QuantitySelector__CurrentQuantity").setAttribute("disabled", true);
    }
  }

  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      document.documentElement.style.setProperty(
        "--cartHeader-height",
        document.querySelector(".CartHeader").offsetHeight + "px"
      );

      if (this.options["showRecommendations"] && this.element.querySelector(".CustomCart__Recommendations ")) {
  
          this.loadRecommendations();
        
      }

    }
    this.initInformation();
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const _this = this;

    const disabled = true;
    this.toggleButtons(disabled);
    this.toggleLoader(target);

    const id = target.getAttribute("data-line-id");
    const quantity = target.tagName === "INPUT" ? target.value : target.getAttribute("data-quantity");
    const items = this.itemsToUpdate(id, quantity);

    const cartData = await this.updateJS(items);
    await _this.renderCart(false, false);
  }

  // returns list of items that need to be removed
  // made for gift bag and swim bag
  itemsToUpdate(id, quantity) {
    let thisProduct, giftBag, swimBag;
    let swimProductsInCart = 0;
    const items = { updates: {} };

    quantity = Number(quantity);
    items['updates'][`${id}`] = quantity;

    CartDrawer.cart.items.forEach(product => {
      const type = product.product_type.toLowerCase();

      if (product.key === id) {
        thisProduct = product;
        swimProductsInCart += quantity;
      } else if (type.includes("swim") || type.includes("bikini")) {
        swimProductsInCart += product.quantity;
      } else if (type.includes('bag_gift')) {
        swimBag = product;
      } else if (type.includes('gift wrapper')) {
        giftBag = product;
      }
    })

    if (!thisProduct || thisProduct.quantity < quantity) return items;

    if (swimBag && swimBag.quantity > swimProductsInCart) {
      const swimBagElement = this.element.querySelector(`[data-key="${swimBag.key}"]`);
      this.toggleLoader(swimBagElement);

      items['updates'][`${swimBag.key.toString()}`] = swimProductsInCart;
    }

    if (!giftBag) return items;

    let normalProductsInCart = CartDrawer.cart.item_count - thisProduct.quantity + quantity - giftBag.quantity;
    if (swimBag) normalProductsInCart -= swimBag.quantity;

    if (normalProductsInCart < giftBag.quantity) {
      const giftBagElement = this.element.querySelector(`[data-key="${giftBag.key}"]`);
      this.toggleLoader(giftBagElement);

      items['updates'][`${giftBag.key.toString()}`] = normalProductsInCart;
    }

    return items;
  }

  onProductAdded() {
    var _this = this;
    this.renderCart().then(function () {
      _this.Drawer.openDrawer();
    });

    this.getCart
  }

  async renderCart(lineNumber, quantityChange) {
      this.pageLoader.style.width = "100%";
    
      try {
        const response = await fetch(
          window.routes.localeRootUrl + "?section_id=main-cart_drawer",
          {
            credentials: "same-origin",
            method: "GET",
          }
        );
    
        const html = await response.text();
        this.replaceContent(html, lineNumber, quantityChange);
    
      } catch (error) {
        console.error("Error rendering cart:", error);
      }
      
  }

  renderMsg(){
    const msgWrap = document.querySelector('.incopatible_message');
    if (document.querySelector('[data-incompatabile="true"]') && msgWrap && document.querySelector('[data-gift="true"]')){
      msgWrap.style.display ="block";
    } else if(msgWrap) {
      msgWrap.style.display = "none";
    }
  }

  updateTotalPrice(){
    const footerTotalParent = document.querySelector(".MetaIcon--Wrappers");
    const footerTotalToReplace = this.tempElement.querySelector(".CartFooter--Totals");

    if (!footerTotalParent || !footerTotalToReplace) return;

    const buyArea = this.element.querySelector('.CartFooter--Buttons');
    if (buyArea) buyArea.style.display = 'grid';

    footerTotalParent.replaceChild(footerTotalToReplace, footerTotalParent.querySelector(".CartFooter--Totals"));
    
  }

  updateCartNumbers(){
    let productsString = window.languages.products;
    const cartCountDrawer = this.element.querySelector('.cartCountDrawer');

    const cart = this.tempElement.querySelector("#cart") ? this.tempElement.querySelector("#cart") : this.tempElement.querySelector("#cart-checkout");
    if (!cart) return;

    this.tempOptions = JSON.parse(cart.getAttribute("data-settings"));

    if (window.location.href.indexOf("cart") != -1) {
      this.tempOptions = JSON.parse(
        this.tempElement.querySelector("#cartPage").getAttribute("data-settings")
      );
    } else {
      this.tempOptions = JSON.parse(
        this.tempElement.querySelector("#cart").getAttribute("data-settings")
      );
    }

    const number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML =  number;
    window.theme.cartCount = parseInt(number);

    if(number == 1){
      productsString = window.languages.product;
    }

    if(cartCountDrawer){
      cartCountDrawer.innerText = `${number} ${productsString}`;
    }
  }
  
  handleExpressButtons() {
   
    let observer;
    const observerCallback = (mutations) => {

        mutations.forEach((mutation) => {
          

            mutation.addedNodes.forEach((node) => {


              

                if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('[data-shopify-buttoncontainer]') || this.element.querySelector('#dynamic-checkout-cart undefined')) {
                  const applePay = this.element.querySelector('[data-testid="ApplePay-button"]');
                  if (applePay) {
                    const containerElement = applePay.parentElement; // Assuming applePay is a direct child of the container
                    const parentContainer = containerElement.parentElement;
                    containerElement.style.cssText = "display: block !important;";
                    const allPayment = parentContainer.querySelectorAll('li');
                    allPayment.forEach((item) => {

                      if(item != containerElement){
                        item.style.display = "none";
                      }
                    })
                  }
                  if (node.querySelector('undefined') || this.element.querySelector('#dynamic-checkout-cart undefined')){

        
                    const textEl = this.element.querySelector('#dynamic-checkout-cart undefined');

                    if (textEl) {
                        const text = textEl.textContent;
                        const div = document.createElement('div');
                        div.innerText = text;
                        div.classList.add('CartFooter--ButtonText');
                        div.classList.add('u-p2');
                      
                        textEl.style.display = "none";
                        if(document.querySelector('.CartFooter--ButtonText'))return;
                        document.querySelector('.CartFooter--ButtonBox').append(div);
                    }
                  } else if(node && document.querySelector('.CartFooter--ButtonText')){
                    document.querySelector('.CartFooter--ButtonText').remove();
                  }

            
                }else if(node && document.querySelector('.CartFooter--ButtonText')){
                  document.querySelector('.CartFooter--ButtonText').remove();
                }
                this.Drawer.maxHeight();
            });
        });
    };

    const observerOptions = { childList: true, subtree: true };
    const buttonBox = document.querySelector('#dynamic-checkout-cart');

    if (buttonBox) {

        observer = new MutationObserver(observerCallback);
        observer.observe(buttonBox, observerOptions);
    }
  }

  replaceContent(html, lineNumber, quantityChange) {
    const _this = this;
    let atcButton = _this.element.querySelector('.CartFooter--Buttons .Button');
    let checkoutBtn = _this.element.querySelector('.dynamicCheckout');

    atcButton?.setAttribute('disabled', true);
    checkoutBtn?.setAttribute('disabled', true);
    
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = "0px";
    this.pageLoader.style.width = "0%";
    setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
    }, 550);

    // Create temporary element to hold the new HTML
    this.tempElement = document.createElement("div");
    this.tempElement.innerHTML = html;

    if (window.location.href.indexOf("cart") != -1) {
      this.tempOptions = JSON.parse(
        this.tempElement.querySelector("#cartPage").getAttribute("data-settings")
      );
    } else {
      this.tempOptions = JSON.parse(
        this.tempElement.querySelector("#cart").getAttribute("data-settings")
      );
    }

    this.options = this.tempOptions;

    // Update cart header
    const cartHeader = this.element.querySelector('.CartHeader');
    const newCartHeader = this.tempElement.querySelector('.CartHeader');

    if (cartHeader && newCartHeader) {
        cartHeader.innerHTML = newCartHeader.innerHTML;
    }

    if (lineNumber && this.tempElement.querySelector("#" + lineNumber)) {
        const cartNodeParent = this.element.querySelector("#" + lineNumber);
        const itemToReplaceWith = this.tempElement.querySelector("#" + lineNumber + " .cartItem--Informations");

        const loader = cartNodeParent.querySelector(".itemLoader");
        loader?.classList.remove("is-visible");

        if (itemToReplaceWith) {
            const oldItem = cartNodeParent.querySelector(".cartItem--Informations");

            if (oldItem) {
                cartNodeParent.replaceChild(itemToReplaceWith, oldItem);
                this.updateCartNumbers();
            }
        } else {
            // Remove item and potentially gifts and bags
            cartNodeParent.remove();
            if (this.options["showRecommendations"] && this.element.querySelector(".CustomCart__Recommendations ")) {
                this.loadRecommendations();
            }
        }

        this.updateCartNumbers();

        if (window.theme.cartCount > 0) {
            this.updateTotalPrice();
            this.initInformation();
        } else {
            const mainPartParent = this.element.querySelector(".CartDrawer");
            const newCartDrawer = this.tempElement.querySelector(".CartDrawer");
            if (mainPartParent && newCartDrawer) {
                mainPartParent.innerHTML = newCartDrawer.innerHTML;
            } else if (newCartDrawer) {
                this.element.innerHTML = newCartDrawer.innerHTML;
            }
        }

        if (this.element.querySelector(".itemLoader")) {
            setTimeout(() => {
                this.element.querySelector(".itemLoader").classList.remove("is-visible");
            }, 250);
        }
    } else {
        if (window.location.href.indexOf("cart") !== -1) {
          const mainPartParent = this.element.querySelector("#cartData");
          const newCartDrawer = this.tempElement.querySelector("#cartData");

          if (!newCartDrawer) return window.location.reload();

          mainPartParent.innerHTML = newCartDrawer.innerHTML;

          const cartNodeParent = this.element.querySelector(".CartPage");
          const newCartItemsWrapper = this.tempElement.querySelector(".CartItems--Wrapper");
          const oldCartItemsWrapper = this.element.querySelector(".CartItems--Wrapper");

          if (cartNodeParent && newCartItemsWrapper && oldCartItemsWrapper) {
              cartNodeParent.replaceChild(newCartItemsWrapper, oldCartItemsWrapper);
          }

          const currentScrollPosition = this.element.querySelector("#main-cartItems").scrollTop;
          this.element.querySelector("#main-cartItems").scrollTop = currentScrollPosition;

          this.updateTotalPrice();
          this.updateCartNumbers();
          this.initInformation();

        } else {
            const cartNodeParent = this.element.querySelector(".CartDrawer");
            const newCartItemsWrapper = this.tempElement.querySelector(".CartItems--Wrapper");
            const oldCartItemsWrapper = this.element.querySelector(".CartItems--Wrapper");

            if (cartNodeParent && newCartItemsWrapper && oldCartItemsWrapper) {
                cartNodeParent.replaceChild(newCartItemsWrapper, oldCartItemsWrapper);
            }

            const currentScrollPosition = this.element.querySelector("#main-cartItems").scrollTop;
            this.element.querySelector("#main-cartItems").scrollTop = currentScrollPosition;

            this.updateTotalPrice();
            this.updateCartNumbers();
            setTimeout(() => {
              this.initInformation();
            }, 200);
        }
    }

    this.recommendationsLoaded = false;

    atcButton?.removeAttribute('disabled');
    checkoutBtn?.removeAttribute('disabled');

    setTimeout(() => {
        if (this.options["showRecommendations"] && !quantityChange && this.element.querySelector(".CustomCart__Recommendations ")) {
            this.loadRecommendations();
        }

        const focus = _this.element.querySelector("[data-scrollable]");
        if (focus) bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

        _this.Drawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    const _this = this;
    const productId = this.options?.productId;

    if (!productId) return;

    if(this.options['productId'] == ''){
      var url =
          "?section_id=helper-recommendations";
    } else {
      var url = productId
      ? `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=10`
      : "?section_id=helper-recommendations";
    }

    
    return fetch(url).then(function (response) {
      return response
        .text()
        .then(function (content) {
          var container = document.createElement("div");
          container.innerHTML = content;
          // Insert the recommendations HTML into the recommendations container.
          const upsellContainer = container.querySelector(".cartUpsell");
          const recommendationsContainer = _this.element.querySelector(
            ".CustomCart__Recommendations"
          );

          const recommendationsTitle = _this.element.querySelector('.CustomCart--title');
  
          if (recommendationsContainer &&
            recommendationsContainer.querySelector(".cartSlideItem") &&
            upsellContainer.querySelector(".cartSlideItem") &&
            _this.recommendationsLoaded == true &&
            recommendationsContainer.querySelector(".cartSlideItem").id ==
              upsellContainer.querySelector(".cartSlideItem").id
          ) {
            return;
          }
          recommendationsContainer?recommendationsContainer.innerHTML = upsellContainer.innerHTML:null;


          if (_this.element.querySelector(".diffSwiper")) {
            const swiper = new Swiper(".swiperUpsell", {
              // Default parameters
              slidesPerView: 2,
              spaceBetween: 2,
              navigation: false,
              loop: false,
              scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
              },
              breakpoints: {
                1025: {
                  slidesPerView: 4,
                  spaceBetween: 2,
                },
              },
            });
          } else {
            const swiper = new Swiper(".swiperUpsell", {
              // Default parameters
              slidesPerView: 3,
              spaceBetween: 2,
              navigation: false,
              loop: false,
              scrollbar: {
                el: ".CustomCart__Recommendations .swiper-scrollbar",
                draggable: true,
              },
              breakpoints: {
                1025: {
                  slidesPerView: 4,
                  spaceBetween: 2,
                },
              },
            });
          }

          _this.recommendationsLoaded = true;
          // Dispatch a custom event to toggle favorites state.
  
          // Show the recommendations section and run the Revolution animation if enabled.
  
          const recommendationsSection = _this.element.querySelector(
            ".CustomCart__Recommendations"
          );
          setTimeout(() => {
           if(recommendationsSection) recommendationsSection.style.display = "block";
           if(recommendationsTitle) recommendationsTitle.style.display = "block";
          }, 200);

          const cartDrawerRecommendation = _this.element.querySelector(".CustomCart__Recommendations");
  
          let cartDrawerSlidesRecommendation = _this.element.querySelectorAll('.CustomCart__Recommendations .cartSlideItem');
          if (cartDrawerSlidesRecommendation.length === 0) {
           if(recommendationsTitle) recommendationsTitle.style.display = "none";
           if(cartDrawerRecommendation) cartDrawerRecommendation.style.display = 'none';
          }

          if(_this.element.id == "cart-checkout") {
            const productCards = _this.element.querySelector('.swiperUpsell').querySelectorAll('mobile-button-handler');
            productCards.forEach(card => new ProductCardButtonMobile(card));
        
          }
        })
        .catch((e) => {
          console.error(e);
        });
    });
  }

  toggleButtons(disabled) {
      const atcButton = this.element.querySelector('.CartFooter--Buttons .Button');
      const checkoutBtn = this.element.querySelector('.dynamicCheckout');
    
      atcButton?.setAttribute('disabled', disabled);
      checkoutBtn?.setAttribute('disabled', disabled);
  }

  toggleLoader(target) {
      target?.closest(".cartItem").querySelector(".itemLoader").classList.add("is-visible"); 
  }

  async updateJS(items) {
      try {
          const response = await fetch(window.routes.localeRootUrl + "/cart/update.js", {
              body: JSON.stringify(items),
              credentials: "same-origin",
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
              },
          });

          return await response.json();
      } catch (e) {
          console.error("Error when updating quantity: ", e);
      }
  }
}

customElements.define("cart-drawer", CartDrawer);

let listenerFeatured = false;
class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    if(new Responsive().matchesBreakpoint('pocket') && this.element.dataset.layout == 'slider'){
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
 
    }
    if(listenerFeatured == false){
      this.loadListener = this.loadRecommendationsInstant.bind(this);
      document.addEventListener("content:reload", this.loadListener);
      listenerFeatured = true;
    }


    if(this.element.dataset.url){
      this.loadRecommendations();
    }

  }

  disconnectedCallback() {
    this.domDelegate.destroy();
    this.delegateBody.destroy();
  }
 
  loadRecommendationsInstant(){

    fetch(this.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector("featured-collection");
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        if(this.element.dataset.layout == 'slider'){
          this.carouselElement = this.element.querySelector(".swiper");
          this.carousel = new RevolutionSwiper(this.carouselElement);

        }
      }
    })
    .catch((e) => {
      console.error(e);
    });
  }

  loadRecommendations(){
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("featured-collection");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            if(this.element.dataset.layout == 'slider'){
              this.carouselElement = this.element.querySelector(".swiper");
              this.carousel = new RevolutionSwiper(this.carouselElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-200px 0px 0px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);


class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    
    this.carouselElement = this.element.querySelector(".swiper");
    if (this.carouselElement) this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);

    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-link]", this.handleLinkClick.bind(this));
  }
  
  handleLinkClick() {
    const target = event.target.closest("[data-link]");
    if (!target) return;

    const link = target.dataset.link;
    window.location.href = link;
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {

       
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);

        }
      
        
        _this.observer.unobserve(_this);
      }
    });
    
  }
  changeImageQuality(singleItem) {
    const responsive = new Responsive();
    const imageWidth = responsive.matchesBreakpoint("lap-and-up")
      ? 2600
      : 1200;

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    imageContainers.forEach(container => {
      const images = container.querySelectorAll(".Banner__Image");
  
      images.forEach(image => {
        // Skip the image if it has already been loaded.
        if (image.dataset.loadedImage === "true") {
          return;
        }
  
        const replaceUrl = image.dataset.src.replace(
          "{width}x",
          `width=${imageWidth}`
        );
        image.src = replaceUrl;
        image.dataset.loadedImage = "true";
      });
    });
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.prevOffset = window.scrollY;
    
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }
    this.isOpen = false;
    if (this.options.sticky) {
      this.toggleSticky();
    }
    this.bindEvents();
    this.menuOverlapHandler();
  }


updateVisibleHeight() {
  const rect = this.element.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  // Calculate the visible height
  let visibleHeight =
    Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

   
  // Ensure the visibleHeight is never negative
  visibleHeight = Math.max(visibleHeight, 0);
  // Update the height of .announcementBar with the visible height
  document.documentElement.style.setProperty(
    "--header-dynamic-height",
    `${visibleHeight}px`
  );
}

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);
    if (!this.options.sticky) {
      this.toggleTopBarListener = this.toggleTopBar.bind(this);
    }

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
    window.addEventListener("scroll", this.toggleColorListener);
    window.addEventListener("scroll", this.toggleTopBarListener);

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-haspopup='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-haspopup='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "#header",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      ".header--LogoWrapper",
      this.closeMenu.bind(this),
      true
    );


    this.delegateElement.on(
      "mouseenter",
      ".SetRight",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "keydown",
      "[aria-haspopup='true']",
      (event, target) => {
        if (event.key === "Escape" || event.key === " ") {
          this.closeMenu(event, target);
        }
      }
    );

    if (this.options.transparent) {
      this.delegateBody.on(
        "header:transparent",
        (e) => {
          !e.detail ? this.element.classList.remove('Header--Transparent') : setTimeout(() => this.element.classList.add('Header--Transparent'), 330);
          !e.detail ? this.element.style.borderColor = "var(--secondary_grey_light)" : setTimeout(() => this.element.style.borderColor = "transparent", 330);
        },
        true
      );
    }
  }


  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
  
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent("drawer:close-other", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);
    this.element.classList.remove("Header--Transparent");
    target.setAttribute("aria-expanded", "true");

    // Close any siblings of the target element.

    const siblings = Array.from(target.closest('.header--MenuItems').children).filter(
      (child) =>
        child.querySelector('.header--hoverLinks') !== target && child.querySelector('.header--hoverLinks').getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.querySelector('.header--hoverLinks').setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    const scrollableElement = this.element.querySelector("[data-scrollable]");
    if (!scrollableElement) {
      return;
    }
    bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);
    this.isOpen = true;
  }

  closeMenu(event, target) {
    if(this.isOpen == false){return;}
    if (event && event.type === "mouseleave" && target !== event.target) {
      return;
    }
    if (this.options["transparent"]) {
      this.element.classList.add("Header--Transparent");
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });
    this.toggleColor();
    const scrollableElement = this.element.querySelector("[data-scrollable]");
    if (!scrollableElement) {
      return;
    }

    bodyScrollLock.enableBodyScroll(scrollableElement);
    this.isOpen = false;
  }

  toggleColor() {
    let annBar = document.querySelector(".announcementBar");
    let element_height = this.element.offsetHeight;
    document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
    setTimeout(() => document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px'), 350);

    if (window.pageYOffset >element_height + annBar.offsetHeight) {
      this.element.closest('.shopify-section').classList.add("Header--Scrolled");
      if (this.options.transparent) {
        this.element.classList.remove("Header--Transparent");
    }
    } else {
      this.element.closest('.shopify-section').classList.remove("Header--Scrolled");
      if (this.options.transparent) {

        this.element.classList.add("Header--Transparent");
      
    }
    }
 
  }

  toggleTopBar() {
    let current = window.scrollY;
    let annBar = document.querySelector(".announcementBar");
    let element_height = this.element.offsetHeight;

    if (element_height + annBar.offsetHeight < current) {
  
      this.element.parentElement.classList.add("header--fixed-top-bar");
    }
  
    if (current <= annBar.offsetHeight) {
    
      this.element.parentElement.classList.remove("header--fixed-top-bar");
    }
   
    if (this.prevOffset < current && current >= (annBar.offsetHeight + this.element.offsetHeight)) {
      this.element.parentElement.classList.add("header--hide");
    } else {
      this.element.parentElement.classList.remove("header--hide");
    }

    this.prevOffset = current;
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    const allDrawer = this.element.querySelectorAll(".Drawer--wrapper");
    allDrawer.forEach((item) => {
      new Drawer(item);
    });

    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );

  }

  toggleNextElement(event, target) {
    event.preventDefault();
    const nextEl = target.getAttribute("data-toggle-id"),
      subdrawer = this.element.querySelector("#" + nextEl);
      const focus = subdrawer.querySelector('[data-scrollable]');
    if (subdrawer && subdrawer.getAttribute("aria-hidden") == "true") {
      subdrawer.setAttribute("aria-hidden", "false");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }
  }

  togglePreviusElement(event, target) {
    const focus = target.closest(".SidebarDrawer--Wrapper");
    focus.setAttribute("aria-hidden", "true");

    bodyScrollLock.enableBodyScroll(focus.querySelector('[data-scrollable]'), bodyScrollLockOptions);
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class MarketSelectorDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.marketDrawer = new Drawer(this.element);
    this.domDelegate = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=market-drawer-submit]",
      this.selectorDrawerSubmit.bind(this)
    );

    this.domDelegate.on(
      "keydown",
      "[data-action=market-drawer-submit]",
      (event, target) => {
        if (event.key === "Enter" || event.key === " ") {
          this.selectorDrawerSubmit(event, target);
        }
      }
    );

  }

  selectorDrawerSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    let value = event.target.getAttribute("data-value");
    let dataName = event.target.getAttribute("data-name");
    let localization_form = this.element.querySelector("#market_selector");
    let country_code_input = localization_form.querySelector(
      'input[name="country_code"]'
    );
    country_code_input.value = value;
    localization_form.submit();
  }
}
customElements.define("market-selector-drawer", MarketSelectorDrawer);

class LanguageDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.languageDrawer = new Drawer(this.element);
    this.domDelegate = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=language-drawer-submit]",
      this.languageDrawerSubmit.bind(this)
    );
  }

  languageDrawerSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    let value = event.target.getAttribute("data-value");
    let dataName = event.target.getAttribute("data-name");
    let localization_form = this.element.querySelector(
      "#LanguageSelector--Form"
    );
    let country_code_input = localization_form.querySelector(
      'input[name="language_code"]'
    );
    country_code_input.value = value;
    localization_form.submit();
  }
}
customElements.define("language-drawer", LanguageDrawer);

class CartGiftwrappDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.giftwrappDrawer = new Drawer(this.element);
    const idElem = this.element.querySelector("input[data-productid]");
    if (idElem) {
      const id = idElem.value;
      new AddToCart(this.element, id);
    } else {
      new AddToCart(this.element);
    }
    this.bindEvents();
  }
  bindEvents() {
    this.closeListener = this.giftwrappDrawer.closeDrawer();
    this.element
      .querySelector('[data-action_giftwrapper="close_drawer"]')
      .addEventListener(
        "click",
        this.closeListener
      );
  }
}

customElements.define("cart-giftwrapp-drawer", CartGiftwrappDrawer);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  static idList = [];
  static collectionElementList = [];

  constructor() {
    super();
    this.element = this;
    const collectionBlockId = this.element.dataset.collectionVideo;
    
    if (collectionBlockId) {      
      const stopInitializing = VideoComponent.collectionElementList.some(element => element.dataset.collectionVideo === collectionBlockId);
      
      if (stopInitializing) return;

      VideoComponent.collectionElementList.push(this.element);
    }    

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    const pdp = this.element.dataset.product === "true";
    if (pdp) {
      this.delElem = new Delegate(this.element);
      this.bindPdpEvents();
    }

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {

        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {

      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );

    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindPdpEvents() {
    this.delElem.on("play:video", () => { this.videoPlayer.play(); });
    this.delElem.on("pause:video", () => { this.videoPlayer.pause() });
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {

    if (!this.element.getAttribute("loaded")) {

      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type = host === "youtube" ? "video/youtube" : host === "vimeo" ? "video/vimeo" : "video/mp4";        

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: this.options["poster"] || false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel",
          "fullscreenToggle",
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };
    this.host = host;
    
    const videoplayerID = this.element.querySelector("video");


    if (VideoComponent.idList.includes(videoplayerID.id)) {
      videoplayerID.id += "-" + Math.random();
    }
        
    VideoComponent.idList.push(videoplayerID.id);
    this.videoPlayer = videojs(videoplayerID, payload);    

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options['muted'] && host == 'vimeo') {
      this.videoPlayer.on('play', function () {

        _this.videoPlayer.muted("true");
      })
    }



    if (this.options["controls"]) {
      if (host == 'html5'){
      this.videoPlayer.on("touchstart", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }
  
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });}
      if(host == 'html5') return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }
  
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
        
          if(this.options['muted'] || this.host == 'vimeo' || this.host == 'youtube'){
            this.videoPlayer.muted("true");
          }
        
      
          const checkIfPlaying = () => {
          
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.footerDelegate = new Delegate(this.element);
    this.delegateElement = new Delegate(this.element);
    this.delegate = new Delegate(this.element);

    this.resizeObserver = new ResizeObserver(changes => {
      for(const change of changes){
        document.documentElement.style.setProperty('--footer-height', document.querySelector('.mainfooterWrapper').offsetHeight + 'px');

      }
    })

    this.resizeObserver.observe(this);

    const newsletterWrapper = this.element.querySelector(
      ".Newsletter--Wrapper.not_mobile"
    );
    const textAlign = newsletterWrapper?.getAttribute("data-align");
    if (textAlign === "true") {
      this.handleMarginSet();
    } else {
      newsletterWrapper.style.marginTop = "1rem";
    }

    this.newsletterInputs = this.element.querySelectorAll(".CustomerNewsletterFooter");

    if(this.element.querySelector('.scrollTo--Success') && sessionStorage.getItem('footerNewsletter') === 'true') {
      window.scrollTo(0, document.body.scrollHeight);
      sessionStorage.setItem('footerNewsletter', 'false');
    }

    this.form = this.element.querySelector('#footerFormDesktop');
    //form.addEventListener('submit', this.handleFormSubmit.bind(this));
    const mensCheckbox = this.element.querySelector('#mensCheckboxDesktop');
    const womensCheckbox = this.element.querySelector('#womensCheckboxDesktop');
    if(mensCheckbox != null || womensCheckbox != null){
      mensCheckbox.addEventListener('change', this.hideErrorMessage.bind(this));
      womensCheckbox.addEventListener('change', this.hideErrorMessage.bind(this));
    }
    

    this.formMob = this.element.querySelector('#footerFormMobile');
    //formMob.addEventListener('submit', this.handleFormSubmitMob.bind(this));
    const mensCheckboxMob = this.element.querySelector('#mensCheckboxMobile');
    const womensCheckboxMob = this.element.querySelector('#womensCheckboxMobile');
    if(mensCheckboxMob != null || womensCheckboxMob != null){
      mensCheckboxMob.addEventListener('change', this.hideErrorMessageMob.bind(this));
      womensCheckboxMob.addEventListener('change', this.hideErrorMessageMob.bind(this));
    }
    
    
    this.bindEvents();
  }
  
  bindEvents() {
    this.footerDelegate.on(
      "change",
      '[data-action="update-newsletter"]',
      this.updateNewsletterInput.bind(this)
    );
    this.footerDelegate.on(
      "keydown",
      '.agree__label',
      (event, target) => {
        if (event.key === "Enter") {
          const checkboxId = target.getAttribute('for');
          if (checkboxId) {
            const checkbox = document.getElementById(checkboxId);
            if (checkbox) checkbox.click();
          }
        }
      }
    );
    this.footerDelegate.on(
      "click",
      '[data-action="catch"]',
      () => sessionStorage.setItem('footerNewsletter', 'true')
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-form"]',
      this.handleFormSubmit.bind(this)
    );
    this.delegate.on(
      'keypress',
      '[data-action="submit-form"]', 
      this.handleFormSubmit.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="submit-mobForm"]',
      this.handleFormSubmitMob.bind(this)
    );
  }

  updateNewsletterInput(e) {
    const targetEl = e.target;

    if (targetEl.checked) {
      if (targetEl.value === "men's")
      this.newsletterInputs.forEach(input => input.value = input.value + ", men's");
      else if (targetEl.value === "women's")
      this.newsletterInputs.forEach(input => input.value = input.value + ", women's");
    } else {
      if (targetEl.value === "men's")
        this.newsletterInputs.forEach(input => input.value = input.value.replace(
          ", men's",
          ""
        ));
      else if (targetEl.value === "women's")
        this.newsletterInputs.forEach(input => input.value = input.value.replace(
          ", women's",
          ""
        ));
    }
  }

  async handleFormSubmit(event) {
    if (event instanceof KeyboardEvent && event.key !== "Enter") return;
  
    const mensCheckbox = this.element.querySelector('#mensCheckboxDesktop');
    const womensCheckbox = this.element.querySelector('#womensCheckboxDesktop');
    const errorMessage = this.element.querySelector('.error_message.desk');

    event.preventDefault();

    if (mensCheckbox || womensCheckbox) {
      if (!mensCheckbox.checked && !womensCheckbox.checked) {
        errorMessage.style.display = 'block';
        return; // Zaustavi dalje izvršavanje ako nijedan checkbox nije označen
      }
    }

    errorMessage.style.display = 'none';

    const email = this.element.querySelector('#email_desktop_input').value;
    
    const listId = this.element.dataset.klaviyoListId;
    const source = "Footer";

    await subscribeToKlaviyo(email, listId, source);
    this.form.submit();
  }

  hideErrorMessage() {
    const errorMessage = this.element.querySelector('.error_message.desk');
    errorMessage.style.display = 'none';
  }

  async handleFormSubmitMob(event) {
    event.preventDefault();

    const mensCheckbox = this.element.querySelector('#mensCheckboxMobile');
    const womensCheckbox = this.element.querySelector('#womensCheckboxMobile');
    const errorMessage = this.element.querySelector('.error_message.mob');

    event.preventDefault();

    if (mensCheckbox || womensCheckbox) {
      if (!mensCheckbox.checked && !womensCheckbox.checked) {
        errorMessage.style.display = 'block';
        return; // Zaustavi dalje izvršavanje ako nijedan checkbox nije označen
      }
    }

    errorMessage.style.display = 'none';

    const email = this.element.querySelector('#email_mobile_input').value;
   
    const listId = this.element.dataset.klaviyoListId;
    const source = "Footer";

    await subscribeToKlaviyo(email, listId, source);
    this.formMob.submit();
  }

  hideErrorMessageMob() {
    const errorMessage = this.element.querySelector('.error_message.mob');
    errorMessage.style.display = 'none';
  }

  handleMarginSet() {

      let footerDropdownContent = Array.from(this.element.querySelectorAll('.Dropdown:not(.not_desktop)'));
      if (footerDropdownContent.length > 0) {
     
         footerDropdownContent = footerDropdownContent[footerDropdownContent.length - 1];
    }
    const height = footerDropdownContent.querySelector('.footer--LinkList').clientHeight;

    const first = footerDropdownContent.querySelector(
      ".footer--LinkList__Item:first-of-type"
    );
    const last = footerDropdownContent.querySelector(
      ".footer--LinkList__Item:last-of-type"
    );
    if (first && last){
    const heightFirst = first.offsetHeight;
    const heightLast = last.offsetHeight;
      
    const margin = height - (heightFirst + heightLast);

    this.element.querySelector(".FooterHeader--desktop").style.marginBottom =
      margin + "px";
  }}
}
customElements.define("footer-component", FooterComponent);
class DropdownPDP {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.dropdownElements = this.element.querySelectorAll(".DropdownPDP");
    this.blockWrapper = this.element.querySelector(".mainProductDropdownContent--wrapper");

    this.initializeDropdown();
  }

  initializeDropdown() {
    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();

    if (this.shouldInitializeDropdown(breakpoint)) {
      this.handleFirst();
      this.bindEvents();
    }
  }

  shouldInitializeDropdown(breakpoint) {
    return (
      (breakpoint === "phone" || breakpoint === "tablet") &&
      this.element.getAttribute("id") !== "size-guide-drawer-contentID"
    );
  }

  handleFirst() {
    const dropdownEl = this.element.querySelector(".DropdownPDP");
    const dropdownButton = dropdownEl?.querySelector(".Dropdown--ButtonPDP");
    const dropdownElContent = dropdownEl?.querySelector(".Dropdown--ContentPDP");

    if (dropdownButton && dropdownElContent) {
      dropdownButton.setAttribute("aria-expanded", "true");
      dropdownElContent.setAttribute("aria-hidden", "false");
      this.setHeight(this.blockWrapper, dropdownElContent);
    }
  }

  setHeight(el, absolutEl) {

    if (el && absolutEl) {
      el.style.height = `${absolutEl.offsetHeight + this.getHeightOfBtn()}px`;
    }
  }

  getHeightOfBtn() {
    return this.element.querySelector(".Dropdown--ButtonPDP")?.offsetHeight || 0;
  }

  bindEvents() {
    if (this.domDelegate) {
      this.domDelegate.on("click", "[data-action=toggle-dropdown-pdp]", this.handleDropdown.bind(this));
    }
  }

  handleDropdown(event, target) {
    event.preventDefault();

    const elementToHandle = target?.parentNode;

    if (elementToHandle) {
      const dropdownButton = elementToHandle.querySelector(".Dropdown--ButtonPDP");

      if (dropdownButton?.getAttribute("aria-expanded") === "false") {
        this.closeOtherContent(elementToHandle);

        target.setAttribute("aria-expanded", "true");
        elementToHandle.querySelector(".Dropdown--ContentPDP").setAttribute("aria-hidden", "false");
        const contentHeight = elementToHandle.querySelector('.Dropdown--ContentPDP[aria-hidden="false"]');
        this.setHeight(this.blockWrapper, contentHeight);
      }
    }
  }

  closeOtherContent(el) {
    const openEl = this.element.querySelector('.Dropdown--ButtonPDP[aria-expanded="true"]');
    const parentEl = openEl?.parentNode;

    if (openEl && parentEl) {
      openEl.setAttribute("aria-expanded", "false");
      parentEl.querySelector(".Dropdown--ContentPDP").setAttribute("aria-hidden", "true");
    }
  }
}



var contentCache = {};
var contentCacheUrl = {};
class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.domBodyDelegate  = new Delegate(document.body);
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();
    this.isPaddingAdded = false;
    if( this.element.querySelector(".notifyMe--Overlay")){
      this.notifyMeOverlayElement = this.element.querySelector(".notifyMe--Overlay");
    }

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
      this.carouselElement = this.element.querySelector(".mainSwiper");

      if (this.options["slides_number"] > 1) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    // Swiper for size guide tabs
    if (this.element.querySelector("#size-guide-swiper-id")) {
      this.carouselElSizeGuide = this.element.querySelector(
        "#size-guide-swiper-id"
      );
      this.carouselSizeGuide = new RevolutionSwiper(this.carouselElSizeGuide);
    }
 
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );

    var localPickup = this.element.querySelector("#LocalPickup");

    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }

    new AddToCart(this.element);

    // Size guide first el open
    if (this.element.querySelector(".sizeGuideInner--tab ")) {
      this.makeFirstTabOpenAndSetHeight();
    }
    // Here we handle dropdown for mobile
    if (
      this.element.querySelector(".mainProductDropdownContent--wrapper") &&
      (this.breakpoint === "phone" || this.breakpoint === "tablet")
    ) {
      new DropdownPDP(this.element.querySelector(".ProductInfo--Wrapper"));
    }

    if (this.options["enable_zoom"]) {
      const images = this.element.querySelectorAll(".mainProductInfo--swiperWrapper img");
      new CustomImageZoom(this.element, images);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

  

    this.complementaryEl = this.element.querySelector(
      ".complementary_products--wrapper"
    );

    if (this.complementaryEl) {
      this.handleComplementaryProducts();
    }

    
    const allDrawers = this.element.querySelectorAll('.DrawerPDP');

    allDrawers.forEach((item) =>{
 
      if (item.dataset.name == 'dopdownMob-DrawerDesk' && new Responsive().matchesBreakpoint("lap-and-up")){
        new Drawer(item);

      } else if(item.dataset.name != 'dopdownMob-DrawerDesk'){
   
        new Drawer(item);
      }

    })

    if(this.element.querySelector('.variantBundles--columnsWrapper')){
      this.handleVariantAndBundleOpenState(this);
    }

    this.checkSubs();
    
    if(this.options['new_pdp']){
      this.handlePrevBtn();
      this.showMoreHandle();

      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        this.initStickyElements();
      }
    }

    this.trimDesc();
    this.handleJourney();

    if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
      this.initMobileStickyAtcClass();
    }
  }

  connectedCallback() {
    //Handle position of variant and quantity bundles
    if(this.element.querySelector('.variantBundles--columnsWrapper')){
      document.addEventListener(
        "scroll",
        () => this.handleVariantAndBundleOpenState(this)
      );
    }
    
    //Notify me 
    this.domDelegate.on(
      "click",
      '[data-action="notify-me"]',
      this.openNotifyMe.bind(this)
    );

    this.domDelegate.on(
      "click",
      '.closeNotifyMePopUp[data-action="close-modal"]',
      this.closeNotifyMe.bind(this)
    );

    this.domBodyDelegate.on(
      "click",
      '.notifyMe--Overlay.is-visible',
      this.closeNotifyMe.bind(this)
    );

    //Reload without refresh the page
    window.addEventListener(
      "DOMContentLoaded",this.reloadWithoutRefresh.bind(this)
    );
   
    //Handle size picker if variant is not choosen
    this.domDelegate.on(
      "click",
      '[data-action="open-sizepicker"]',
      this.toggleSizePicker.bind(this)
    );

    //Toggle selected size
    this.domDelegate.on(
      "click",
      '[data-action="toggle-size"]',
      this.getVariantSize.bind(this)
    );

    // Swiper for size guide tabs shadow at the end

    setTimeout(() => {
      this.calculateMaxHeightListener = this.setHeight.bind(this);
      window.addEventListener("resize", this.calculateMaxHeightListener);
    }, 150);

    //Event for size guide tabs
    this.domDelegate.on(
      "click",
      '[data-action="toggle-dropdown-sizeGuide"]',
      this.toggleSizeGuideTabs.bind(this)
    );
    this.domDelegate.on(
      "click",
      '[data-action="subscribe-enter"]',
      this.handleSubsBtn.bind(this)
    );

    this.domDelegate.on(
      "click",
      '[data-action="toggle-dropdown-sizeGuide"]',
      this.setProgressBar.bind(this)
    );


    this.domDelegate.on(
      "click",
      '[data-action="toggle-connected-items"]',
      this.toggleAllConectedItems.bind(this)
    );
    this.domDelegate.on(
      "keydown",
      '[data-action="toggle-connected-items"]',
      (event, target) => {
        if (event.key === "Enter" || event.key === " ") {
          this.toggleAllConectedItems(event, target);
        }
      }
    );

    this.domDelegate.on(`click`, `.pdpLinks`, this.handleReloadClick.bind(this));

    this.domDelegate.on(
      "click",
      '[data-action="unsubscribe"]',
      this.unsubscribe.bind(this)
    );

    this.domDelegate.on(
      "mouseover",
      '[data-action="connected-color"]',
      this.connectedColor.bind(this)
    );

    this.domDelegate.on(
      "click",
      '[data-action="connected-color"]',
      this.saveVariantToSession.bind(this)
    );

    this.domDelegate.on(
      "click",
      '[data-action="connected-product"]',
      this.saveVariantToSession.bind(this)
    );

    this.domDelegate.on(
      "touchstart",
      '[data-action="connected-color"]',
      this.connectedColor.bind(this)
    );

    this.domDelegate.on(
      "mouseout",
      '[data-action="connected-color"]',
      this.resetConnectedColor.bind(this)
    );
    
    this.domDelegate.on(
      "click",
      '[data-action="show-more"]',
      this.toggleShowMore.bind(this)
    );

    window.addEventListener('popstate', function(event) {
      // Handle back/forward button click here
      // You can retrieve the old state from event.state
      location.reload();
    });

    this.domDelegate.on("variant:unsubscribe", this.unsubscribe.bind(this));
   
    const videoWrappers = this.element.querySelectorAll(".videoWrapper");
    videoWrappers.forEach(elem => {
      elem.addEventListener("mouseenter", this.handleMouseOverVideo.bind(this));
      elem.addEventListener("mouseleave", this.handleMouseLeftVideo.bind(this));
    });

    if (videoWrappers.length && this.carousel) {
      this.carousel.swiperElement.on("slideChangeTransitionEnd", this.handleSlideChange.bind(this));
    }

    const lapAndUp = new Responsive().matchesBreakpoint("lap-and-up");

    if (lapAndUp) {
      window.addEventListener('resize', this.calculateHeightsForSticky.bind(this));
      this.domDelegate.on("element:size:change", this.calculateHeightsForSticky.bind(this));
      this.domDelegate.on('click', '.mainProduct__variant', this.scrollToTop.bind(this));
    } else {
      this.carousel.swiperElement.on("slideChangeTransitionStart", this.handlePrevBtn.bind(this));
    }

    document.addEventListener("scroll", this.initMobileStickyAtcClass.bind(this));
        
  }

  

  handleJourney() {
    // Customer journey + template hydration: product (PDP) URLs only.
    if (!window.location.pathname.includes("/products/")) return;

    const collectionHandle = this.element.dataset.handle || "";

    const templates = document.querySelectorAll('.breadcrumbs__collection-journey');
    if (!templates.length) return;

    // Rule A: only show journey breadcrumbs when user came from a collection page.
    let cameFromCollection = false;
    let allowPdpToPdpPersist = false;
    try {
      allowPdpToPdpPersist = sessionStorage.getItem("breadcrumbs_persist_next_pdp") === "1";
      if (document.referrer) {
        const refUrl = new URL(document.referrer);
        cameFromCollection = refUrl.pathname.includes('/collections/');
      }
    } catch (e) {
      cameFromCollection = false;
      allowPdpToPdpPersist = false;
    }
    if (allowPdpToPdpPersist) {
      try { sessionStorage.removeItem("breadcrumbs_persist_next_pdp"); } catch (e) {}
    }
    if (!cameFromCollection && !allowPdpToPdpPersist) return;

    const fallbackWrapper = document.querySelector('.breadcrumbs__journey-fallback');
    const fallbackCollections = [];
    if (fallbackWrapper) {
      const links = fallbackWrapper.querySelectorAll('a.breadcrumbs__link, a');
      links.forEach((link) => {
        const url = link.getAttribute('href') || '';
        const name = (link.textContent || '').trim();
        if (!url || !name) return;
        fallbackCollections.push({ url, name });
      });
    }

    let collections = [];

    try {
      collections = JSON.parse(
        sessionStorage.getItem('breadcrumbs_journey')
      ) || [];
    } catch (e) {
      collections = [];
    }

    collections = collections.filter(c => c?.handle && c.handle !== collectionHandle);

    // Anchor journey to the actual navigation: when coming from a collection page, only
    // use crumbs that end at the referred collection (at most one "parent" from session).
    // This avoids showing two stale, unrelated collections from an old sessionStorage tail.
    let refHandle = null;
    if (cameFromCollection) {
      try {
        if (document.referrer) {
          const refPath = new URL(document.referrer).pathname;
          const m = refPath.match(/\/collections\/([^/?#]+)/);
          if (m) refHandle = decodeURIComponent(m[1]);
        }
      } catch (e) {
        refHandle = null;
      }
    }

    let journeyCollections = [];
    if (cameFromCollection && refHandle) {
      const idx = collections.findIndex(c => c.handle === refHandle);
      if (idx >= 0) {
        journeyCollections = collections.slice(Math.max(0, idx - 1), idx + 1);
      } else {
        // Referred collection not in session (stale/empty) — use referrer only for journey slot 1.
        try {
          const refUrl = new URL(document.referrer);
          const path = refUrl.pathname.split('?')[0];
          const url = refUrl.origin + path;
          const name = refHandle
            .split("-")
            .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
            .join(" ");
          journeyCollections = [{ url, name, handle: refHandle }];
        } catch (e) {
          journeyCollections = [];
        }
      }
    } else if (allowPdpToPdpPersist) {
      // PDP -> connected PDP: keep last up to 2 from session (same chain as before).
      journeyCollections = collections.slice(-2);
    }

    // Combine: journey first, then section fallback to fill remaining slot(s).
    const combined = [];
    journeyCollections.forEach((c) => {
      if (c?.url && c?.name) combined.push({ url: c.url, name: c.name });
    });
    fallbackCollections.forEach((c) => {
      if (combined.length >= 2) return;
      const isDup = combined.some(x => x.url === c.url || x.name === c.name);
      if (!isDup) combined.push(c);
    });

    if (!combined.length) return;
    if (fallbackWrapper) fallbackWrapper.remove();

    const maxToRender = Math.min(combined.length, templates.length);
    for (let i = 0; i < maxToRender; i++) {
      const template = templates[i];
      const journeyCollection = combined[i];
      if (!journeyCollection?.url || !journeyCollection?.name) continue;

      const fragment = template.content.cloneNode(true);

      const links = fragment.querySelectorAll('a.breadcrumbs__link, a');
      links.forEach((link) => {
        link.href = journeyCollection.url;
        link.textContent = journeyCollection.name;
      });

      template.replaceWith(...fragment.childNodes);
    }
  }

  initStickyElements() {    
    this.stickyElements = this.buildStickyElemsList();
    if (!this.stickyElements?.length) return;

    this.stickyWrapperElems = this.buildStickyWrapperElems();

    this.setCssForSticky();
    this.setCssForStickyWrapper();

    requestAnimationFrame(() => {
      this.calculateHeightsForSticky();
    })
  }

  buildStickyElemsList() {
    const array = [];

    const wrapper = this.element.querySelectorAll(".ProductInfo--Wrapper > *");
    wrapper.forEach(elem => {
      if (this.isSticky(elem)) array.push(elem);
    })    

    return array;
  }

  setCssForSticky(array, variable) {
    this.stickyElements.forEach((elem, index) => {
      let string = "calc(var(--header-height) - 1px + var(--breadcrumbs-height) +"; 

      for (let i = 0; i < index; i++) {
        string += ` var(--stick-elem-${i}) +`;
      }

      string = string.slice(0, -2)
      string += ")";

      elem.style.top = string;
      index++;
    })
  }

  setCssForStickyWrapper() {
    document.documentElement.style.setProperty(
      "--breadcrumbs-height",
      `${document.querySelector(".breadcrumbs--wrapper").offsetHeight}px`
    );
    let string = "calc(("; 
    
    this.stickyWrapperElems.forEach((elem, index) => {
      string += `var(--stick-wrapper-elem-${index++}) + `;
    })

    string = string.slice(0, -3)
    string += ")* (-1) + var(--breadcrumbs-height))";

    this.element.querySelector(".ProductInfo--Wrapper").style.top = string;    
  }

  calculateHeightsForSticky() {
    function getHeight(elem) {
      const rect = elem.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(elem);
      const marginTop = parseFloat(computedStyle.marginTop);
      const marginBottom = parseFloat(computedStyle.marginBottom);
      
      return Math.floor(rect.height) + marginTop + marginBottom;
    }

    if (!this.stickyElements?.length) return;
    const root = document.querySelector(':root');

    // height for sticky elements
    this.stickyElements.forEach((elem, index) => {
      const height = getHeight(elem);
      const variable = "--stick-elem-" + index++;
      
      root.style.setProperty(variable, height + "px");
    })

    // height for main wrapper
    if (!this.stickyWrapperElems.length) return;

    this.stickyWrapperElems.forEach((elem, index) => {
      const height = getHeight(elem);      
      const variable = "--stick-wrapper-elem-" + index++;
      
      root.style.setProperty(variable, height + "px");
    })
  }

  buildStickyWrapperElems() {
    const array = [];

    // only take elements that are in between of fixed elements
    const first = this.stickyElements[0];
    const last = this.stickyElements[this.stickyElements.length - 1];

    const parent = this.element.querySelector(".ProductInfo--Wrapper");
    const children = Array.from(parent.children);

    const firstIndex = children.indexOf(first);
    const lastIndex = children.indexOf(last);
   
    for (let i = firstIndex; i < lastIndex; i++) {
      const child = children[i];

      if (child.tagName === "SCRIPT" || child.tagName === "STYLE" || child.tagName === "NOTIFY-ME-POPUP" ||
          child.classList.contains("Drawer--wrapper") || child.classList.contains("pageOverlaySizeGuidePDP") 
          || this.isSticky(child) || child.classList.contains("product__buy-buttons-scripts")) continue;

      array.push(child);
    }
    
    return array;
  }

  isSticky(elem) {
    const stickyElementClasses = ["ProductInfo--Title", "main-product__text-block", "main-product__sticky-atc"];
    const classList = [...elem.classList];

    return classList.some(className => stickyElementClasses.includes(className));
  }

  initMobileStickyAtcClass() {
    const stickyWrapper = this.element.querySelector(".main-product__mobile-sticky-atc");
    if (!stickyWrapper) return;

    const productActions = stickyWrapper.querySelector(".ProductActions");
    if (!productActions) return;

    if (!this._mobileStickyAtcHandlers) {
      let raf = 0;

      const update = () => {
        const actionsRect = productActions.getBoundingClientRect();
        const viewportBottom = window.innerHeight || document.documentElement.clientHeight || 0;
        const bottomTolerance = 2;

        const isStickyToBottom = viewportBottom > 0 && actionsRect.bottom >= viewportBottom - bottomTolerance;

        stickyWrapper.classList.toggle("is-sticky", isStickyToBottom);
        productActions.classList.toggle("is-sticky", isStickyToBottom);
      };

      const onScrollOrResize = () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          update();
        });
      };

      this._mobileStickyAtcHandlers = { update, onScrollOrResize };

      window.addEventListener("scroll", onScrollOrResize, { passive: true });
      window.addEventListener("resize", onScrollOrResize);
    }

    this._mobileStickyAtcHandlers.update();
  }

  scrollToTop(){
    window.scroll({
      top: 0, 
      behavior: 'smooth' 
    });
  }

  handlePrevBtn(){
    this.activeSlide = this.element.querySelector('.swiper-slide.swiper-slide-active');
    this.firstSlide = this.activeSlide.getAttribute('data-swiper-slide-index');
        
    this.prevButton = this.element.querySelector('.prevEl');
    if (!this.prevButton) return;

    if (this.firstSlide === '0') {
      this.prevButton.style.display = 'none';
    } else {
      this.prevButton.style.display = 'flex';
    }
  }

  connectedColor(target){    
    this.targetElement = event.target.getAttribute('data-name');
    this.colorName = this.element.querySelector('.option_name');
    this.dataColor = this.colorName.getAttribute('data-color');

    if(this.targetElement != '' && this.dataColor != ''){
      this.colorName.innerHTML = this.targetElement;
    } else {
      this.colorName.innerHTML = this.dataColor;
    }
  }

  saveVariantToSession() {
    const target = event.target.closest('[data-action="connected-color"], [data-action="connected-product"]');
    const link = target.dataset.link;
    if (!link) return;

    // Preserve breadcrumbs journey when navigating PDP -> connected PDP.
    try {
      sessionStorage.setItem("breadcrumbs_persist_next_pdp", "1");
    } catch (e) {}

    const variantSelectes = document.querySelector("variant-selects");
    if (!variantSelectes) return location.href = link;

    const currentVariant = variantSelectes.dataset.currentVariant || null;
    const optionWrapperWithoutSelected = variantSelectes.querySelector(".mainProduct__variants:not(:has( input:checked))");
    if (!optionWrapperWithoutSelected) sessionStorage.setItem("last_variant", currentVariant);

    location.href = link;
  }

  resetConnectedColor(event) {
    const colorName = this.element.querySelector('.option_name');
    const dataColor = colorName.getAttribute('data-color');

    if (dataColor) {
      colorName.innerHTML = dataColor;
    }
  }


  toggleShowMore() {
    const wrapper = event.target.closest(".main-product__show-more");

    const content = wrapper.querySelector(".main-product__show-more-content:not(.main-product__show-more-dummy-content)");
    const expanded = content?.getAttribute("aria-expanded") === "true";

    content?.setAttribute("aria-expanded", !expanded);

    if (expanded) {
      content.scrollTo({
        top: 0,
        behavior: 'smooth', 
      });
    }
  }

  showMoreHandle(){
    const description = this.element.querySelector('.main-product__show-more-content');
    const button = this.element.querySelector('.main-product__show-more-button');

    if (!description || !button) return;    
    
    if((description.offsetHeight + 10) > description.scrollHeight) {
      button.style.display = 'none';
    }
  }

  closeShowMoreDrawer() {
    const drawer = this.element.querySelector('.main-product__show-more-drawer[aria-hidden="false"]');
    if (!drawer) return;

    bodyScrollLock.clearAllBodyScrollLocks();

    const overlay = document.querySelector(".pageOverlay");
    overlay.classList.remove("is-visible");
    overlay.removeEventListener("click", this.overlayEvent);

    drawer.setAttribute("aria-hidden", true);
  }

  // Check only target input 
  getVariantSize(event, target){
    const allSizes = this.element.querySelectorAll('.mainProduct__variant input[type="checkbox"]');
    allSizes.forEach((inputElement) =>{
      inputElement.checked = false;
    });
    target.checked = true;
  }

  handleSlideChange() {
    const videoWrapper = this.checkIfSlideIsVideo();
    videoWrapper?.dispatchEvent(new CustomEvent("play:video", { bubbles: true }));
  }

  checkIfSlideIsVideo() {
    return this.element.querySelector(".swiper-slide-active .videoWrapper .video-js");
  }

  handleMouseOverVideo() {
    const videoJs = event.target.querySelector(".video-js");
    videoJs.dispatchEvent(new CustomEvent("play:video", { bubbles: true }));
  }

  handleMouseLeftVideo() {
    const videoJs = event.target.querySelector(".video-js");
    videoJs.dispatchEvent(new CustomEvent("pause:video", { bubbles: true }));
  }

  checkSubs(){
    const subscriptionToggler = document.querySelector('.mainProduct--subBtnWrapper.mainPdp--drawerBtn');

    if (!subscriptionToggler) return;

    const addButton = document.querySelector(".ProductPage--ATC");
    const input = subscriptionToggler.querySelector('input[type="checkbox"]');

    // Check is it variant checked or not
    // if not do nothing
    const variantInputs = document.querySelectorAll('.mainProduct__variant input[type="radio"]');

    subscriptionToggler.addEventListener("click", ()=> {
      const isVariantChecked = Array.from(variantInputs).some(variant => variant.checked);
      // console.log(isVariantChecked)
      if(variantInputs != null && isVariantChecked === true){
        subscriptionToggler.removeAttribute('data-action');
      }
      if(input && input.checked){
        if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
          addButton.setAttribute('data-action', 'subscribe-enter');
        } else {
          addButton.setAttribute('data-action', 'toggle-drawer');
          addButton.setAttribute('data-toggle-id', 'subscription-drawer');
        }
        
      } else {
        addButton.setAttribute("data-action", "add-to-cart");
      }
    })
  }

  handleVariantAndBundleOpenState(){
    let elementToCount = this.element.querySelector('.variantBundles--columnsWrapper');
    let rect = elementToCount.getBoundingClientRect();

    let elementMidpoint = rect.top + rect.height /2;
    let viewportMidpoint = window.innerHeight / 2;

    const arrowsDown = elementToCount.querySelectorAll('.Svg--arrow-down');
    const arrowsUp = elementToCount.querySelectorAll('.Svg--arrow-top');
    const selectBoxContents = this.element.querySelectorAll('.variantBundles--columnsWrapper .RevolutionSelectbox--Content');

    if(elementMidpoint < viewportMidpoint){
     arrowsDown.forEach(svgDown => 
      svgDown.style.display = "flex");

      arrowsUp.forEach(svgUp => 
        svgUp.style.display = "none");

        if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
            selectBoxContents.forEach(item =>{
                item.style.top = "40px"; 
                item.style.bottom = "unset"; 
            }
            );
      }else{
        selectBoxContents.forEach(item =>{
          // item.style.top = "48px"; 
          item.style.bottom = "unset"; 
      }
      );
      }

    } else{
      arrowsDown.forEach(svgDown => 
        svgDown.style.display = "none");
  
        arrowsUp.forEach(svgUp => 
          svgUp.style.display = "flex");

      if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
          selectBoxContents.forEach(item =>{
            item.style.bottom = "40px";
            item.style.top = "unset";
          }
          );
        } else{
          selectBoxContents.forEach(item =>{
            item.style.bottom = "48px";
            item.style.top = "unset";
          }
          );
        }
    }
  }

  openNotifyMe(e){    
    e.preventDefault();
    const notifyMePopUp = this.element.querySelector('.notifyMePopUp--wrapper[aria-hidden="true"]');
    if(notifyMePopUp){
      //add choosen variants
      let form = this.element.querySelector('.form.mainPDP--formBtns');
      let inputID = form.querySelector('input[name="id"]');
      let variantINFO = inputID.getAttribute('value');
      notifyMePopUp.setAttribute('variant-value', `${variantINFO}`);

      let selectedVariantsText = "";
      const variantWrappers = this.element.querySelectorAll('.mainProduct__box-selectors[data-option-name]');
      variantWrappers.forEach(elem => {
        const selectedOption = elem.querySelector("input:checked")?.value;        
        selectedVariantsText = `${selectedVariantsText} ${elem.dataset.optionName}: ${selectedOption},`;
      })

      selectedVariantsText = variantWrappers.length ? selectedVariantsText.substring(0, selectedVariantsText.length - 1) : "";

      const productColor = this.element.querySelector('.mainProduct--ColorText');

      this.element.querySelector('.notifyMePopUp--Size').textContent = selectedVariantsText;
      this.element.querySelector('.notifyMePopUp--Color').textContent = productColor.textContent.trim();
      
      notifyMePopUp.setAttribute('aria-hidden', 'false');
      this.notifyMeOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

     
    }
  }

  closeNotifyMe(){
    const notifyMePopUp = this.element.querySelector('.notifyMePopUp--wrapper[aria-hidden="false"]');
    if(notifyMePopUp){
      notifyMePopUp.setAttribute('aria-hidden', 'true');
      this.notifyMeOverlayElement.classList.remove("is-visible");
      bodyScrollLock.clearAllBodyScrollLocks();

      notifyMePopUp.querySelector('.notifyMePopUp--successMsg').style.display = 'none';
      notifyMePopUp.querySelector('.notifyMePopUp--content').style.display = 'flex';

      notifyMePopUp.querySelector('.notifyMe--Input').value = "";
    }
  }

  reloadWithoutRefresh() {
    let pdpLinks = this.element.querySelectorAll('product-component .pdpLinks');
    let urlsToFetch = Array.from(pdpLinks).map(link => link.href);

    // Function to fetch and cache content for a URL

    const fetchAndCacheContent = async (url) => {
 

  
      try {
        const response = await fetch(url);
  
        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] =new DOMParser()
          .parseFromString(htmlContent, "text/html")
          .querySelector(".product-module");

          contentCacheUrl[url] =new DOMParser()
          .parseFromString(htmlContent, "text/html")
          .querySelector('featured-collection').dataset.url;
        } else {
          console.error('Error fetching data. HTTP status:', response.status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    // Fetch content for all pdpLinks when the page loads
    urlsToFetch.forEach((url) => {
      fetchAndCacheContent(url);
    });
  
 

  }

  getTitleFromUrl(url) {
    const parts = url.split('/');
    return parts[parts.length - 1];
  }

  updateContentWithoutReload(url) {
    const htmlContent = contentCache[url];

    if (htmlContent) {
      document.body.querySelector(`.product-module`).innerHTML = htmlContent.innerHTML;

      if(document.querySelector('featured-collection')){
        document.querySelector('featured-collection').dataset.url = contentCacheUrl[url];

        document.dispatchEvent(new CustomEvent("content:reload", { bubbles: true }));
      }
      // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Update the title of the document  
      document.title = this.getTitleFromUrl(url);
    

      // Optionally, update the URL in the address bar without a full page reload
      history.pushState(null, null, url);
      this.handleExpressButtons();
      if (
        this.element.querySelector(".mainProductDropdownContent--wrapper") &&
        (this.breakpoint === "phone" || this.breakpoint === "tablet")
      ) {
        new DropdownPDP(this.element.querySelector(".ProductInfo--Wrapper"));
      }
    } else {
      
      window.location.href = url;
      
    }

  }

  handleExpressButtons() {
    Shopify.PaymentButton.init();
    let observer;
    const observerCallback = (mutations) => {

        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('[data-shopify-buttoncontainer]')) {
                  const applePay = this.element.querySelector('[data-testid="ApplePay-button"]');
                  if (applePay) {
                    const containerElement = applePay.parentElement; // Assuming applePay is a direct child of the container
                    const parentContainer = containerElement.parentElement;
                    containerElement.style.cssText = "display: block !important;";
                    const allPayment = parentContainer.querySelectorAll('li');
                    allPayment.forEach((item) => {

                      if(item != containerElement){
                        item.style.display = "none";
                      }
                    })
                  }
            
                  observer.disconnect();
            
                }
         
            });
        });
    };

    const observerOptions = { childList: true, subtree: true };
    const buttonBox = document.querySelector('.productForm--aditionalCheckoutButtons');

    if (buttonBox) {

        observer = new MutationObserver(observerCallback);
        observer.observe(buttonBox, observerOptions);
    }
}
  
  handleReloadClick(){

    event.preventDefault();
    const url = event.target.href

    this.updateContentWithoutReload(url);
  }

  handleSubsBtn(event){
    let checkedOption = false;
    this.element.querySelector('.Product--SubscriptionButton[aria-selected="true"]')?checkedOption=true:checkedOption=false;
    if(!checkedOption){
      this.element.querySelector('.subscriptionErrorMsg').style.display = "block";
      setTimeout(() => {
        this.element.querySelector('.subscriptionErrorMsg').style.display = "none";
      }, 3000);     
      return;
    }
   const elementToClick = this.element.querySelector(".subscriptionsInner--headerWrapper .Drawer--Closer[data-action='close-drawer']");
   elementToClick.click();

     //update text for subs btn if plan is choosen
    
     let choosenPlan = this.element.querySelector('.Product--SubscriptionButton[aria-selected="true"]');
     let defaultPrice =this.element.querySelector('.ProductPage--ATC .mainProductBtn--price').textContent;
   
     let choosenPrice = this.element.querySelector('.Product--SubscriptionButton[aria-selected="true"] .Product--SubscriptionPrice').textContent;
     if(choosenPlan){
      let choosenPlanTxtForBtn = this.element.querySelector('.subscribedTxtBtn');

      this.element.querySelector('.subCheckbox--icon.full').classList.remove('hidden');
      this.element.querySelector('.subCheckbox--icon.empty').classList.add('hidden');

      //choosenPlanTxtForBtn.innerHTML = choosenPlan.dataset.info;
      this.element.querySelector('.notsubscribedTxtBtn').style.display = "none";
      this.element.querySelector('.subscribedTxtBtn').style.display = "block";    

      this.element.querySelector('.subCheckbox--icon.full').classList.remove('hidden');
      this.element.querySelector('.subCheckbox--icon.empty').classList.add('hidden');  

      //change data action state for button so user can unsubscribe (disable open drawer)
      this.subsMainBtnDrawer = this.element.querySelector('.mainProduct--subBtnWrapper.mainPdp--drawerBtn');
      this.subsMainBtnDrawer.setAttribute('data-action', 'unsubscribe');

      //update price in the button
      this.element.querySelector('.ProductPage--ATC .mainProductBtn--price').setAttribute('data-price', `${defaultPrice}`)
      this.element.querySelector('.ProductPage--ATC .mainProductBtn--price').textContent = choosenPrice;
   

     }else{
      this.unsubscribe(defaultPrice);
     }
   
  }

  unsubscribe(e){
    const priceElem = this.element.querySelector('.ProductPage--ATC .mainProductBtn--price');
    const price = priceElem?.getAttribute('data-price');  

    if(priceElem && price) priceElem.textContent = price;
  
   
    if(this.element.querySelector('.notsubscribedTxtBtn') && this.element.querySelector('.subscribedTxtBtn')){
        this.element.querySelector('.notsubscribedTxtBtn').style.display = "flex";
        this.element.querySelector('.subscribedTxtBtn').style.display = "none"; 
    }
    if( this.element.querySelector('.subCheckbox--icon.full') && this.element.querySelector('.subCheckbox--icon.empty')){
        this.element.querySelector('.subCheckbox--icon.full').classList.add('hidden');
        this.element.querySelector('.subCheckbox--icon.empty').classList.remove('hidden');
    }

    if(this.element.querySelector('.Product--SubscriptionButton[aria-selected="true"')){
      document.querySelector('#selling_plan').value = "";
      this.element.querySelector('.Product--SubscriptionButton[aria-selected="true"').setAttribute("aria-selected","false");
    }else{
        e.target.setAttribute('data-action', 'toggle-drawer');
    }

    const htmlString = `
    <div data-shopify="payment-button" data-has-selling-plan="true" data-has-fixed-selling-plan="false" data-customer-accounts-required="false" class="shopify-payment-button u-p2">
      <button class="shopify-payment-button__button shopify-payment-button__button--unbranded shopify-payment-button__button--hidden" disabled="disabled" aria-hidden="true">&nbsp;</button>
      <button class="shopify-payment-button__more-options shopify-payment-button__button--hidden" disabled="disabled" aria-hidden="true">&nbsp;</button>
    </div>
  `;
  
      const payNow = document.querySelector('.productForm--aditionalCheckoutButtons');
      if(payNow){
        payNow.innerHTML = htmlString;
        this.handleExpressButtons();
      }
  }

  toggleSizePicker(event) {
    event.preventDefault();
    event.stopPropagation();

    const wrapperWithoutSelected = this.element.querySelector(".mainProduct__box-selectors:not(:has(input:checked))");
    let errorMsg = wrapperWithoutSelected?.querySelector('.selectSize__msg');

    if(errorMsg){
      errorMsg.setAttribute("aria-hidden", false);
      document.querySelector(".ProductInfo--Wrapper")?.classList.toggle("reload-css");

      this.calculateHeightsForSticky();

      const desktop = new Responsive().matchesBreakpoint("lap-and-up");
      const title = this.element.querySelector(".mainProduct--ColorText") || wrapperWithoutSelected;
      const stickyHeader = document.querySelector(".header--Sticky")?.offsetHeight || 0;
      const top = desktop ? 0 : title.getBoundingClientRect().top + window.scrollY - stickyHeader;

      window.scrollTo({
        top: top,
        behavior: 'smooth', 
      });
    } 

    let buttonElement = this.element.querySelector(
      '.RevolutionSelectbox--Button[data-action="toggle-selectbox-pdp"]'
    );

    // Check if the button element is found
    if (buttonElement) {
      if (this.breakpoint !== "phone" || this.breakpoint !== "tablet") {
        const hoverEvent = new Event('mouseover', { bubbles: true });
        buttonElement.dispatchEvent(hoverEvent);
      }
      if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
          // Simulate a click on the button
          buttonElement.click();
      }
    }
  }

  setProgressBar(event) {
    if (event) {
      //reset scrolled table
      const slider = this.element.querySelectorAll(
        ".sizeGuideInner--tableContent "
      );

      slider.forEach((table) => {
        table.scrollLeft = 0;
      });
    }

    const progressBar = this.querySelector(
      '.sizeGuide--contentDropdown[aria-hidden="false"] .tablePagination'
    );
    const tableContent = this.querySelector(
      '.sizeGuide--contentDropdown[aria-hidden="false"] .sizeGuideInner--tableContent'
    );
    const progressBarWrapper = this.querySelector(
      '.sizeGuide--contentDropdown[aria-hidden="false"] .tablePagination--wrapper'
    );

    // Initial width for the progress bar (adjust as needed)
    let initialWidth =
      (tableContent.clientWidth / tableContent.scrollWidth) * 100; //  initial width

    // Set initial width for progress bar
    progressBar.style.width = `${initialWidth}%`;
    if (tableContent.clientWidth >= tableContent.scrollWidth) {
      progressBarWrapper.classList.add("remove");
    } else {
      progressBarWrapper.classList.remove("remove");

      // Add scroll event listener to update the progress bar width
      tableContent.addEventListener("scroll", () => {
        const scrollPercentage =
          (tableContent.scrollLeft /
            (tableContent.scrollWidth - tableContent.clientWidth)) *
          100;


        const newWidth = Math.max(initialWidth, scrollPercentage);
        progressBar.style.width = `${newWidth}%`;
      });
    }
  }
  makeFirstTabOpenAndSetHeight() {
    setTimeout(() => {
      this.heightHederPlusSwiperTabs =
        this.element.querySelector(
          ".sizeGuideInner--headerWrapper.Drawer--Header"
        ).offsetHeight +
        this.element.querySelector(".sizeGuideInner--sizeGuideTabsWrapper")
          .offsetHeight;
      const firstTab = this.element.querySelector(".sizeGuideInner--tab ");
      const firstTabID = firstTab.getAttribute("tab-id");
      firstTab.setAttribute("aria-expanded", "true");
      const firstTabContent = this.element.querySelector(`#${firstTabID}`);
      firstTabContent.setAttribute("aria-hidden", "false");
      this.setProgressBar();
      this.setHeight();
    }, 100);
  }

  setHeight() {
    const elementToCount = this.element.querySelector(
      ".sizeGuide--contentDropdown[aria-hidden=false]"
    );
    elementToCount
      ? (elementToCount.style.height =
          window.innerHeight - 24 - this.heightHederPlusSwiperTabs + "px")
      : null;
  }

  toggleSizeGuideTabs(event, target) {
    event.preventDefault(event);

  
    if(event.target.getAttribute('aria-expanded') === 'true'){

      return;
    } else if (event.target.getAttribute("aria-expanded") === "false") {
      this.closeOpenOne();
      const toOpenID = event.target.getAttribute("tab-id");
      event.target.setAttribute("aria-expanded", "true");
      this.element
        .querySelector(`#${toOpenID}`)
        .setAttribute("aria-hidden", "false");

      this.setHeight();
    }
  }

  closeOpenOne() {
    this.element
      .querySelector(".sizeGuideInner--tab[aria-expanded=true]")
      .setAttribute("aria-expanded", "false");
    this.element
      .querySelector(".sizeGuide--contentDropdown[aria-hidden=false]")
      .setAttribute("aria-hidden", "true");
  }


  async handleComplementaryProducts() {
    this.block_options = JSON.parse(
      this.complementaryEl.getAttribute("data-block-settings")
    );
    let optionToUse = this.block_options.select_type;
    this.complementaryElWrapper = this.element.querySelector(
      ".complementary_products--wrapper"
    );

    let url = `${window.routes.localeRootUrl}/recommendations/products?section_id=complementary_products_pdp&product_id=${this.options["product_id"]}&limit=10&intent=${optionToUse}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status);
    let content = await response.text();
    content = new DOMParser().parseFromString(content, "text/html");
    let hasProducts;

    const contentToInsert = content.querySelector(
      ".complementaryProducts--section"
    );

    //Init swiper
    this.element
      .querySelector(".complementary_products--PdpSwiper")
      .appendChild(contentToInsert);
    this.carouselComplementary = this.element.querySelector(
      "#complementarySwiperElement"
    );
    if (this.carouselComplementary) {
      this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
    }

    this.childEl = this.element.querySelector(
      ".complementaryProducts--section .complementaryProducts--imageWrapper"
    );

    if (this.childEl) {
      hasProducts = true;
    } else {
      hasProducts = false;
    }
    if (this.complementaryElWrapper && hasProducts) {
      this.complementaryElWrapper.style.display = "block";
    }
  }

  toggleAllConectedItems(e) {
    const wrapper = e.target.closest(".mainProduct--connectedItemsWrapper");
    const expanded = wrapper.getAttribute("aria-expanded") === "false" ? true : false;
    wrapper.setAttribute("aria-expanded", expanded);

    const items = Array.from(this.element.querySelectorAll(".SelectboxImage"));
    let numOfItemsToToggle;
    if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
      numOfItemsToToggle = items.length - 5;
    } else {
      numOfItemsToToggle = items.length - 7;
    }

    const itmesToToggle = items.slice(-numOfItemsToToggle);
    itmesToToggle.forEach((item) => {
      item.classList.toggle("showItem");
    });

    this.calculateHeightsForSticky();
  }

  trimDesc() {
    const firstP = this.element.querySelector(".main-product__show-more-content p");
    if (!firstP || firstP.innerHTML.trim() !== '&nbsp;') return;

    firstP.style.display = 'none';
  }
}
customElements.define("product-component", ProductElement);


class NotifyMePopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '.notifyMePopupSubmit[type="submit"]',
      this.submitNotifyMe.bind(this));

  }

  submitNotifyMe(){
    
    const emailInput = this.element.querySelector('.notifyMe--Input');
    const emailTxt = emailInput.value.trim();
    const alertErr = this.element.querySelector('.notifyMePopUp--content .AlertError');

    //validation for email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailTxt)) {
      // Invalid email format
      alertErr.style.display = "block";
      setTimeout(() => {
        alertErr.style.display = "none";
      }, 3000);
      
      return;
    }else{
      alertErr.style.display = "none";
    }

     //Send request to API
    this.handleKlaviyoAPI(emailInput.value);
   
  }
  async handleKlaviyoAPI(myEmail){  
    let elementWithId = this.element.querySelector('.notifyMePopUp--wrapper');
    
    if(elementWithId){
      
      let variantID = elementWithId.getAttribute('variant-value');
        
       //Klaviyo API data
      const data =  {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
            profile: {
                data: {
                    type: "profile",
                    attributes: {
                        email: myEmail
                    }
                }
            }
        },
        relationships: {
            variant: {
                data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${variantID}`
                }
            }
        }
    };
             

        const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoModulesObject.companyId}`;

        const shopifyResponse = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'accept': 'application/json',
              'revision': '2023-12-15'
          },
          body: JSON.stringify({data}),
      });

      if (!shopifyResponse.ok) {
          throw new Error(`Failed to capture email on Shopify: ${shopifyResponse.statusText}`);
      } 
      // Handle success on Shopify (e.g., show a success message to the user)
      elementWithId.setAttribute('notify-me-success', 'true');
      elementWithId.style.opacity = 0;
      elementWithId.querySelector('.notifyMePopUp--content').style.display = "none";

      setTimeout(() => {
         elementWithId.style.opacity = 1;
         elementWithId.querySelector('.notifyMePopUp--successMsg').style.display = "flex";
      }, 500);
      

      }else{
        return;
      }

  }

}
customElements.define("notify-me-popup", NotifyMePopup);

class ProductDrawerTables extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
  }

  bindEvents() {
    let isDragging = false;
    let startX, startScrollLeft;
    const slider = this.element.querySelector(".sizeGuideInner--tableContent");

    const startDragging = (e) => {
        isDragging = true;
        startX = e.type === "touchstart" ? e.touches[0].pageX : e.pageX;
        startScrollLeft = slider.scrollLeft;
    };

    const stopDragging = () => {
        isDragging = false;
    };

    const move = (e) => {
        e.preventDefault();
        if (!isDragging) {
            return;
        }
        const currentX = e.type === "touchmove" ? e.touches[0].pageX : e.pageX;
        const scroll = currentX - startX;
        slider.scrollLeft = startScrollLeft - scroll;
    };

    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("touchstart", startDragging, false);

    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("touchend", stopDragging, false);

    slider.addEventListener("mousemove", move, false);
    slider.addEventListener("touchmove", move, false);
}

}
customElements.define("table-content", ProductDrawerTables);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.currentVariant = JSON.parse(this.element.dataset.currentVariant);
    
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
  }

  connectedCallback() {
    this.selectFromSession();
    this.enableButtonIfAllSelected();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="select-variant"]', this.selectVariant.bind(this));
    this.delegateBody.on("click", "[data-action=toggle-pickSize]", this.togglePickSize.bind(this));
    this.delegateBody.on("keydown", '[data-action="select-variant"]', this.handleKeyBoardPress.bind(this));
  }

  disconnectedCallback() {
    this.delegateElement.destroy();
    this.delegateBody.destroy();
  }

  handleKeyBoardPress(event, target) {
    if (event.key === "Enter" || event.key === "Escape" || event.key === " ") {
        this.selectVariant(event, target);
    }
  }

  async selectVariant() {
    const target = event.target;
    const input = target.querySelector("input");
    if (!input) return;

    input.checked = "true";

    this.selectHiddenOptions(target, input);

    const processing = true;
    this.toggleAtcContent(processing);
    await this.onVariantChange();

    this.toggleAtcContent(!processing);
    this.setMsg(target);
    this.saveToSession();
  }

  selectHiddenOptions(target, input) {
    const selectedOptionName = target.dataset.optionName;
    const hiddenOptions = this.element.querySelectorAll(`[data-action="sync-on-change"][data-sync-with="${selectedOptionName}"]`);
    
    if (hiddenOptions.length > 0) this.syncHiddenOptions(hiddenOptions, input);
  }

  setMsg(target) {
    const wrapper = target.closest(".mainProduct__box-selectors");
    const msg = wrapper?.querySelector('.selectSize__msg');
    if (!msg) return;

    msg.setAttribute("aria-hidden", true);
      this.element.dispatchEvent(
        new CustomEvent("element:size:change", {
          bubbles: true,
        })
      );

    document.querySelector(".ProductInfo--Wrapper")?.classList.toggle("reload-css");
  }

  syncHiddenOptions(hiddenOptions, newInput) {
    const newValue = newInput.value;

    hiddenOptions.forEach((optionWrapper) => {
      const targetInput = optionWrapper.querySelector(`input[value="${newValue}"]`);

      if (targetInput) {
        const checkedInput =  optionWrapper.querySelector("input.checked");
        if (checkedInput) checkedInput.checked = false;

        targetInput.checked = true;
      }
    });
  }

  async onVariantChange() {
    const optionIds = this.getVariantParams();
    if (!optionIds) return;

    this.updateUrl(optionIds);    // updates browser url so it contins selected options
    const doc = await this.fetchVariantElement(optionIds);  // fetches hole document with new variant element

    this.updateCurrentVariant(doc);   // updates this.currentVariant
    if (!this.currentVariant) return;
    

    this.updateVariantInput();   // updates all product forms input with variant id
    this.renderProductInfo();

    this.updateElements(doc);

    this.element.dispatchEvent(
      new CustomEvent("variant:unsubscribe", {
        bubbles: true,
      })
    );
  }
  
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(button => {
      if (listOfAvailableOptions.includes(button.getAttribute("data-value"))) {
        button.classList.remove("variant-notify-me");
        button.removeAttribute("disabled-variant");
      } else {
        button.setAttribute("disabled-variant", "true");
        button.classList.add("variant-notify-me");
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  togglePickSize(){
    document.querySelector(".mainProduct--txtAddToCard").style.display = "none";
    document.querySelector(".mainProduct--noSelectedVariantTxt").style.display = "flex";
  }

  // cleanup later
  renderProductInfo() {
    //If variant is not available disable subscription
        const subscriptionToggler = document.querySelector('.mainProduct--subBtnWrapper.mainPdp--drawerBtn');
        if (!subscriptionToggler) return;

        if(!this.currentVariant.available) {
          subscriptionToggler.style.opacity = 0.3;
          subscriptionToggler.style.pointerEvents = "none";

          return;
        }

        subscriptionToggler.style.opacity = 1;
        subscriptionToggler.style.pointerEvents = "all";

        const input = subscriptionToggler.querySelector('input[type="checkbox"]');
        const variantInputs = document.querySelectorAll('.mainProduct__variant input[type="radio"]');
        const isVariantChecked = Array.from(variantInputs).some(variant => variant.checked);

        subscriptionToggler.removeAttribute("data-action", "toggle-pickSize");
        subscriptionToggler.setAttribute("data-action", "toggle-drawer");

        if (!input || !input.checked) return;
        if (!variantInputs.length || !isVariantChecked) return subscriptionToggler.setAttribute("data-action", "toggle-pickSize");

        const addButton = document.querySelector(".ProductPage--ATC");

        if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
            addButton.setAttribute('data-action', 'subscribe-enter');
        } else {
            addButton.setAttribute('data-action', 'toggle-drawer');
            addButton.setAttribute('data-toggle-id', 'subscription-drawer');
        }  
  }

  updateSubscriptionPlans(doc) {
        // update subscription plans in old subscription block - if exist
        const subsToUpdate = ".subscriptionWrapper";
        const destinationToUpdate = document.querySelector(subsToUpdate);
        const sourceSubscription = doc.querySelector(subsToUpdate);

        if(sourceSubscription && destinationToUpdate){
          destinationToUpdate.innerHTML = sourceSubscription.innerHTML;
        }
  }

  updatePrices(html) {
    // updates all pdp price elements
    const id = ".ProductInfo--Prices .changePrice, .ProductInfo--prices .changePrice";
    const destinations = document.querySelectorAll(id);
    const source = html.querySelector(id);    

    if (!source) return;

    destinations.forEach((destination) => {
      destination.innerHTML = source.innerHTML;
    });

    // triggers price update for subscription dropdown
    const subDropdown = document.querySelector("subscription-dropdown");
    if (!subDropdown) return;

    subDropdown.dataset.variantPrice = this.currentVariant.price;
  }

  updateQuantityButton(html) {
    const quantityButton = document.querySelector(".QuantityHandler");
    if (!quantityButton) return;
     
    const source = html.querySelector(".QuantityHandler");
    if (source && quantityButton) quantityButton.innerHTML = source.innerHTML;
  }

  toggleAtcFunction() {
    const optionWrapperWithoutSelected = this.element.querySelector(".mainProduct__variants:not(:has( input:checked))");
    if (optionWrapperWithoutSelected) return;

    const addButton = document.querySelector(".ProductPage--ATC"),
      quickBuy = document.querySelector('.productForm--aditionalCheckoutButtons');

    if (!addButton) return;

    let subscriptionInput; 
    const subscriptionToggler = document.querySelector('.mainProduct--subBtnWrapper.mainPdp--drawerBtn');
    
    if(subscriptionToggler) subscriptionInput = subscriptionToggler.querySelector('input[type="checkbox"]');
    
    if (!this.currentVariant.available) {
        addButton.setAttribute("data-action", "notify-me");
        quickBuy?.classList.add('disabled');
        
        return;
    }

    
      if(subscriptionInput && subscriptionInput.checked){
        if (this.breakpoint === "phone" || this.breakpoint === "tablet") {
        
          addButton.setAttribute('data-action', 'subscribe-enter');
        } else {
          addButton.setAttribute("data-action", "toggle-drawer");
          addButton.setAttribute("data-toggle-id", "subscription-drawer");
        }
        
        subscriptionToggler.removeAttribute("data-action");
      } else {
        
        addButton.setAttribute("data-action", "add-to-cart");
        subscriptionToggler?.setAttribute("data-action", "toggle-drawer");
      }
      
      addButton.classList.remove('mainProduct--variantNotSelected');
    
      quickBuy?.classList.remove('disabled');
      addButton.classList.remove("ProductCard--Sold__Out");    
  }


  getPriceElem() {
    if (!window.variantInfo.show_price || !this.currentVariant) return "";

    const quantity = document.querySelector(".QuantitySelector__ProductQuantity")?.value || 1;
    let price = this.currentVariant.price;

    const selectedSubPlan = 
      document.querySelector('subscription-dropdown[aria-expanded="true"] .subscription-dropdown__selling-plan[aria-selected="true"]');

    if (selectedSubPlan) {
      const discountString = selectedSubPlan.dataset.discount;
      const discount = Number(discountString) / 100;

      if (discount) price = price - (price * discount);      
    }

    const finalPrice = Shopify.formatMoney(price * quantity, Shopify.money_format).replace(/,/g, "");
    return `<span class='u-pb1 ml-s mainProductBtn--price'>${finalPrice}</span>`;
  }


  buildAtcAnimation(animationType) {
    const atcText = window.variantStrings.addToCart, 
        addedText = window.variantStrings.addedToCart,
        addingText = animationType === "adding" ? window.variantStrings.addingToCart : window.variantStrings.processing;

    return `
        <span class="atc__text">${atcText}</span> 
        <span class="adding__text">${addingText}</span>
        <span class="added__text">${addedText}</span>
        ${this.getPriceElem()} 
        <span class="loading__dots">
            <span class="loading__dot" style=""></span>
            <span class="loading__dot" style=""></span>
            <span class="loading__dot" style=""></span>
        </span>`;
  }

  updateUrl(optionIds) {
    const url = new URL(window.location);
    optionIds = optionIds || this.getVariantParams();

    url.searchParams.set("option_values", optionIds);
    history.replaceState({}, "", url);
  }

  getVariantParams() {
    const selectedOptions = this.element.querySelectorAll('input:checked');
    const optionIds = Array.from(selectedOptions).map(entry => entry.dataset.optionId).join(",");
    
    return optionIds;
  }
  
  updateCurrentVariant(doc) {
    const newVariantElement = doc?.querySelector("variant-selects");

    if (!newVariantElement) return;

    const newVariantJson = newVariantElement.dataset.currentVariant;
    this.currentVariant = JSON.parse(newVariantJson);
    this.element.dataset.currentVariant = newVariantJson;
  }

  async fetchVariantElement(optionIds) {
    const params = "?option_values=" + optionIds;    
    
    try {
      const response = await fetch(`${window.location.href}${params}`);
      const text = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");
      
      return doc;
      
    } catch (error) {
      console.log(error);
    }
  }

  updateElements(doc) {
    this.updateSubscriptionPlans(doc);
    this.updatePrices(doc);
    this.updateQuantityButton(doc);
    this.replaceVariantOptions(doc);
    this.toggleAtcFunction();
  }

  toggleAtcContent(processing) {
    const button = document.querySelector("product-component .ProductPage--ATC");
    if (!button) return;

    const addButtonInner = button.querySelector(".SelfAlign");
    button.disabled = processing;

    const optionWrapperWithoutSelected = this.element.querySelector(".mainProduct__variants:not(:has( input:checked))");

    if (processing) {
        addButtonInner.innerHTML = this.buildAtcAnimation("processing");

        requestAnimationFrame(() => {
            button.classList.add("processing");
        })

    } else if (optionWrapperWithoutSelected && this.oldButtonState) {
        addButtonInner.innerHTML = this.oldButtonState;
        button.classList.remove("processing");

    } else if (this.currentVariant.available) {
        button.classList.remove("processing");
        requestAnimationFrame(() => { 
          addButtonInner.innerHTML = this.buildAtcAnimation("adding");
        })

    } else {
        button.classList.add("ProductCard--Sold__Out");
        addButtonInner.classList.add("u-pb1");
        addButtonInner.innerHTML = this.getSoldOutButtonText();
    }
  }

  getSoldOutButtonText() {
    if (window.variantInfo?.coming_soon) {
      return window.variantInfo.coming_soon_button_text || "SIGN UP";
    }

    return window.variantStrings.soldOut;
  }

  replaceVariantOptions(doc) {
    const variantOptions = this.element.querySelectorAll(".mainProduct__box-selectors");
    variantOptions.forEach(elem => {
        const optionName = elem.dataset.optionName;
        const checkedInputId = elem.querySelector("input:checked")?.id;
        const newElem = doc.querySelector(`.mainProduct__box-selectors[data-option-name="${optionName}"]`);
        
        elem.replaceWith(newElem);

        if (checkedInputId) {
          const newInput = newElem.querySelector(`input#${checkedInputId}`);
          if (newInput) newInput.checked = true;
        }
    })
  }

  selectFromSession() {
    function checkInput(sizeSelector, i) {
      const optionValue = options[i];
      if (!optionValue) return;

      const input = sizeSelector.querySelector(`[data-action="select-variant"] input[value="${optionValue}"]`);
      if (!input) return;
      
      input.checked = true;
    }

    this.lastSelectedVariant = this.getVariantFromSession();
    if (!this.lastSelectedVariant) return;

    const options = this.lastSelectedVariant.options;    

    const sizeSelectors = document.querySelectorAll('.mainProduct__box-selectors');
    sizeSelectors.forEach(checkInput);
  }

  saveToSession(){
    const currentVariantString = JSON.stringify(this.currentVariant);
    sessionStorage.setItem(`current_variant_${this.element.dataset.productId}`, currentVariantString);
  }

  getVariantFromSession() {
    const lastVariantString = sessionStorage.getItem(`last_variant`);
    const currentVariantString = sessionStorage.getItem(`current_variant_${this.element.dataset.productId}`);

    if (!lastVariantString && !currentVariantString) return null;
        
    sessionStorage.removeItem(`last_variant`);
    const jsonString = lastVariantString && lastVariantString !== "null" ? lastVariantString : currentVariantString;
        
    return JSON.parse(jsonString);
  }

  enableButtonIfAllSelected() {
    const optionWrapperWithoutSelected = this.element.querySelector(".mainProduct__variants:not(:has( input:checked))");
    if (optionWrapperWithoutSelected) this.oldButtonState = document.querySelector(".ProductPage--ATC .SelfAlign").innerHTML;

    const processing = false;
    this.toggleAtcContent(processing);
    this.toggleAtcFunction();
    
    if (this.currentVariant && this.currentVariant.id === this.lastSelectedVariant?.id) this.updateVariantInput();
    else this.selectVariantBasedOnSession();
  }

  selectVariantBasedOnSession() {
    const checkedInput = this.element.querySelector('[data-action="select-variant"]:has( input:checked)');
    
    requestAnimationFrame(() => {
      checkedInput?.click();
    })
  }
}
customElements.define("variant-selects", VariantSelects);
class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.delegateElement = new Delegate(this.element);
    
    
    if( window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || window.performance && window.performance.navigation.type === 1){
      new InfiniteScroll('#mainBlog-PaginationContainer', true);
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
    } else {
      new InfiniteScroll('#mainBlog-PaginationContainer');
      sessionStorage.removeItem('pageState');
      sessionStorage.removeItem('pageStateProduct');
    }

    this.bindEvents();
  }

  bindEvents(){
    this.delegateElement.on(
      'click',
      '[data-action="blog-tap"]',
      this.setLastClick.bind(this)
    );

  }


  setLastClick(event){
    let dataPage = event.target.dataset.page;
    let dataPageProduct = event.target.dataset.id;
    if(!event.target.dataset.page){
      dataPage = event.target.closest('[data-page]').dataset.page;
      dataPageProduct = event.target.closest('[data-page]').dataset.id;
    }
    sessionStorage.setItem('pageState', dataPage);
    sessionStorage.setItem('pageStateProduct', dataPageProduct);
  }
}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
  
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchElement = this;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(".searchInput--clear");
   

   

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }


    this.carouselElement = this.element.querySelector(".searchInitialView");
    if (this.carouselElement && new Responsive().matchesBreakpoint('pocket')) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }

  
    if (document.querySelector("#header").offsetHeight > 0) {
      document.documentElement.style.setProperty(
        "--header-height",
        document.querySelector("#header").offsetHeight + "px"
      );
    }

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onRecentSearchClick.bind(this)
    );
    this.delegateElement.on(
      "keydown",
      '[data-action="search-string"]',
      (event, target) => {
        if (event.key === "Enter" || event.key === " ") {
          this.onRecentSearchClick(event, target);
        }
      }
    );
    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));

    this.delegateBody.on(
      "touchstart",
      ".productCard",
      this.handleHover.bind(this)
    );

    this.delegateBody.on(
      "touchend",
      ".productCard",
      this.removeHandleHover.bind(this)
    );
   
  }

  handleHover(event){
    this.productEl = event.target.closest('.productCard');
    this.productEl.classList.add('touch-active');
  }

  removeHandleHover(event){
    this.productEl = event.target.closest('.productCard');
    this.productEl.classList.remove('touch-active');
  }


  initCarousel() {
    var carousel = this.searchResultsElement.querySelector(
      "[data-swiper-settings]"
    );
       
    if (carousel) {
      this.newCarousel = new RevolutionSwiper(carousel);
    }

  }

  initCarousel_card() {
    console.log("Inicijalizacija nested Swipera...");
    
    var cardSwiper = this.element.querySelectorAll(
      ".productCard .swiper"
    );

    if (cardSwiper.length === 0) {
      console.log("Nema pronađenih Swipera!");
    }
   
    if (cardSwiper) {
      cardSwiper.forEach(element => {
        this.newCardCarousel = new RevolutionSwiper(element);
       
      });
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();
    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    if(isMobile){
      this.initCarousel_card();
      console.log('1')
    }

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    const target = event.target;

    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }

    // Load recommendations if product is enabled and collection is empty and searchSlide is not present

    if (
      !this.element.querySelector(".searchSlide") &&
      this.options["product"] &&
      !this.options["collection"]
    ) {
      this.loadRecommendations();
    }
   
    
    // Show search element and page overlay
    if (isMobile) {
      const search = document.querySelector(".search");
      if (search) {
        search.setAttribute("aria-hidden", false);
      }
    } else {
      const search = target.parentElement.querySelector(".search");
      if (search) {
        search.setAttribute("aria-hidden", false);
      }
    }
  
    
    this.pageOverlayElement.classList.add("is-visible");

    // Dispatch menu close event
    if (this.element) {
      this.element.dispatchEvent(
        new CustomEvent("menu:close", { bubbles: true })
      );
    }

        // Disable scrolling on body
        if (bodyScrollLock && this.element) {
          bodyScrollLock.disableBodyScroll(
            this.element.querySelector("[data-scrollable]"),
            bodyScrollLockOptions
          );
        }

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    const headerSection = document.body
      .querySelector("#header")
      ?.closest(".shopify-section");
    const announcementSection = document.body
      .querySelector(".announcementBar")
      ?.closest(".shopify-section");

    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      if (announcementSection) {
        announcementSection.style.zIndex = "99";
      }
    } else {
      document.querySelector(".pageOverlaySearch").classList.add("is-visible");
    }

    // Set header and announcement bar z-index to 99
    if (headerSection) {
      headerSection.style.zIndex = "99";
    }

    // Remove transparent class from header if options.transparent is true

    if (this.options["transparent"]) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
    }

    if (new Responsive().matchesBreakpoint('pocket')){
      const el = document.querySelector('.header--fixed-top-bar');
      if (el){
        el.style.transform = 'unset';
      }

    }


    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }

    this.element.querySelectorAll('a, button, input, textarea, select')
    .forEach(el => el.setAttribute('tabindex', '0'));
  }

  closeSearch() {
    event.preventDefault();
    var _this = this;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll( this.element.querySelector("[data-scrollable]"), bodyScrollLockOptions); 
    const headerSection = document.body
      .querySelector("#header")
      ?.closest(".shopify-section");
    const announcementSection = document.body
      .querySelector(".announcementBar")
      ?.closest(".shopify-section");
    if (headerSection) {
      headerSection.style.zIndex = "5";
      headerSection.style.backgroundColor = "transparent";
    }
    if (announcementSection) {
      announcementSection.style.zIndex = "5";
    }
    document.body.querySelectorAll(".search").forEach((item, i) => {
      item.setAttribute("aria-hidden", true);
    });
    _this.pageOverlayElement.classList.remove("is-visible");
    document.body.style.position = "relative";
    document.body.style.width = "100%";
    if (_this.options["transparent"] && window.pageYOffset < 25) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    } else {
      document.body
        .querySelector("#header")
        .classList.remove("Header--Transparent");
    }
    document.querySelector(".pageOverlaySearch").classList.remove("is-visible");
    if (new Responsive().matchesBreakpoint('pocket')){
  const el = document.querySelector('.header--fixed-top-bar');
      if (el){
        el.removeAttribute('style');
      }

    }

    this.resetSearch();

    this.isOpen = false;

    this.element.querySelectorAll('a, button, input, textarea, select')
    .forEach(el => el.setAttribute('tabindex', '-1'));
  }

  onInput(event) {
    this.allPredictiveSearchInstances = [];

    this.lastInputValue = event.target.value;

    const _this = this;
    this.searchResultsElement.style.opacity = 0;

    this.clearSearchButton.setAttribute("aria-hidden", "false");
    if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = _this.element.querySelector("searchInput");

      el.setAttribute("value", _this.lastInputValue);
      el.value = _this.lastInputValue;

    } else {
      if (event.keyCode === 13) {
        return;
      }

      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        this.lastInputValue
      )}&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,body&section_id=search-predictive`,
      {}
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);

          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-search-predictive").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );

        if (this.newCardCarousel && this.newCardCarousel.length) {
          this.newCardCarousel.forEach(swiper => swiper.destroy(true, true));
          this.newCardCarousel = [];
        }

        this.element.querySelector(".searchWrapper").innerHTML = resultsMarkup;

        setTimeout(() => {
          if (new Responsive().matchesBreakpoint('pocket')) {
            this.initCarousel();
            this.initCarousel_card();
          }
        }, 500);
                
        this.element.querySelector(".searchWrapper").style.opacity = 1;

        let recentSearches = this.element.querySelector(".search--recentResults");
        if (window.theme.showRecentSearches) {
          if(this.element.querySelector(".searchWrapper").querySelector(".predictiveSearch--noResultContent ")) this.getRecentSearches();
          else if(recentSearches) recentSearches.style = 'none';
          this.recentSearches();
        }

        const focus = this.element.querySelector("[data-scrollable]");
        if (focus) bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

        let newElements = document.querySelectorAll(".Pages--Link p");
        newElements.forEach((el) => {
          const newEl = el.innerText.replace(/[\n\r]+|[\s]{2,}/g, " ").trim();
          if (newEl.length > 40) {
            el.classList.add("ProductCard--Title");
          }
        });
      })

      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }

        throw error;
      });
  }

  loadRecommendations() {
    const _this = this;
    const targetProduct = this.options["product"];
    const recommendationsUrl = `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-search_suggested&product_id=${targetProduct}&limit=8`;

    return fetch(recommendationsUrl)
      .then(function (response) {
        return response.text().then(function (content) {
          const container = document.createElement("div");
          const contentWrapper = document.createElement("div");
          contentWrapper.innerHTML = content;
          container.innerHTML = contentWrapper.innerHTML;

          const newSwiper = _this.element.querySelector(
            ".searchInitial--Products"
          );
          newSwiper.innerHTML = container.querySelector(
            ".helper--searchSuggested"
          ).innerHTML;
          if(new Responsive().matchesBreakpoint('pocket')){
              _this.initCarousel();
              setTimeout(() => {
                _this.initCarousel_card();
                console.log('3')
              }, 500);
          }

          new AddToCart(_this.element);
        });
      })
      .catch(function (error) {
        console.error("Error loading recommendations:", error);
      });
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }

    if (this.options["product"] && this.options["collection"] == "") {
      this.loadRecommendations();
    }

    if(new Responsive().matchesBreakpoint('pocket')){
      this.initCarousel();
      setTimeout(() => {
        this.initCarousel_card();
        console.log('4')
      }, 500);
    }
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(".search--recentResults");
    elementToAdd.style.display = "flex";
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString =
          appendString +
          "<li tabIndex='0' class='u-p1 ' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector("#predictiveSearch--recentSearches").style.display =
        "none";
      const twoColumns = this.querySelector(".predictiveSearch--twoColumns");
      if (twoColumns)
        twoColumns.classList.remove("predictiveSearch--twoColumns");
    }
  }

  onRecentSearchClick(event) {
    const clickedSearchWord = event.target.getAttribute("data-value");
    if (clickedSearchWord) {
      // Set the clicked word in the search input
      this.searchInputElement.value = clickedSearchWord;
      this.searchInputElement.focus();

      // Trigger a search with the clicked word (if needed)
      this.onInput({ target: this.searchInputElement });
    }
  }
}
customElements.define("search-bar", SearchBar);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);


    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");

    this.filterSearchBars = this.element.querySelector(
      ".templateSearch .FilterBar"
    );

    if( window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD || window.performance && window.performance.navigation.type === 1){
      new InfiniteScroll('.Search--Result', true);
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
    } else {
      new InfiniteScroll('.Search--Result');
      sessionStorage.removeItem('pageState');
      sessionStorage.removeItem('pageStateProduct');
    }
    this.bindEvents();
  }


  setLastClick(event){
    let dataPage = event.target.dataset.page;
    let dataPageProduct = event.target.dataset.id;
    if(!event.target.dataset.page){
      dataPage = event.target.closest('[data-page]').dataset.page;
      dataPageProduct = event.target.closest('[data-page]').dataset.id;
    }
    sessionStorage.setItem('pageState', dataPage);
    sessionStorage.setItem('pageStateProduct', dataPageProduct);
  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );

    this.delegateElement.on(
      'click',
      '[data-action="mobile-tap"]',
      this.setLastClick.bind(this)
    );

    this.delegateElement.on("filters:rerendered", () =>
      setTimeout(() => this.updateResultNumber(), 100)
    );

    document.addEventListener(
      "DOMContentLoaded",
      this.updateResultNumber.bind(this)
    );
  }

  updateResultNumber() {
    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");    


    const productNumber = this.element.querySelector('.main-templateSearch--WrapperBtns').dataset.product;
      
    const itemNumber = this.element.querySelector(".itemNumber");
    if (productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    }
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      if (productNumber === 0) {
        this.openProductBtn.style.display = "none";
      }
    }

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleNumber = articleElements.length;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2");
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber !== 0) {
        this.openArticleBtn.style.display = "flex";
      }
    }

    if (productNumber !== 0) {
      this.showProducts();
    }
    if (productNumber === 0 && articleNumber !== 0) {
      this.showArticles();
    }
  }

  openSearch() {
    let newEl = document.querySelectorAll(".searchItem");
    newEl.forEach((el) => {
      el.click();
    });
  }
  showProducts() {
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    const productNumber = productElements.length;
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });
    //show filter and searh bar
    if (productNumber === 0) {
      this.filterSearchBars.style.display = "none";
    } else {
      this.filterSearchBars.style.display = "flex";
    }

    // Update button styles
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");

    this.openProductBtn.classList.add("underline");
    this.openArticleBtn.classList.remove("underline");
  }

  showArticles() {
    //hide filters and search
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    this.filterSearchBars.style.display = "none";
    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(
      ".SearchProductWrapper"
    );
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");

    this.openProductBtn.classList.remove("underline");
    this.openArticleBtn.classList.add("underline");
  }
}

customElements.define("search-component", Search);
class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateElement.on(
      "keydown",
      '.agree_label',
      (event, target) => {
        if (event.key === "Enter") {
          const checkboxId = target.getAttribute('for');
          if (checkboxId) {
            const checkbox = document.getElementById(checkboxId);
            if (checkbox) checkbox.click();
          }
        }
      }
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.newsletterInput = this.element.querySelector("#CustomerNewsletter");

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    const form = this.element.querySelector('#popupForm');
    form.addEventListener('submit', this.handleFormSubmit.bind(this));
    const mensCheckbox = this.element.querySelector('#mensCheckbox');
    const womensCheckbox = this.element.querySelector('#womensCheckbox');
    if(mensCheckbox != null || womensCheckbox != null){
      mensCheckbox.addEventListener('change', this.hideErrorMessage.bind(this));
      womensCheckbox.addEventListener('change', this.hideErrorMessage.bind(this));
    }

    this.bindEvents();

    this.checkForSuccess();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      '[data-action="update-newsletter"]',
      this.updateNewsletterInput.bind(this)
    );
    this.delegateElement.on(
      'click', 
      '[data-action="subscribe-me"]',
      this.popupVisibility.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeNewsletter.bind(this)
    );
  }

  handleFormSubmit(event) {
    const mensCheckbox = this.element.querySelector('#mensCheckbox');
    const womensCheckbox = this.element.querySelector('#womensCheckbox');
    const errorMessage = this.element.querySelector('.error_message');

    if (!mensCheckbox.checked && !womensCheckbox.checked) {
      event.preventDefault();  // Prevent form submission
      errorMessage.style.display = 'block';  // Show error message
    } else {
      errorMessage.style.display = 'none';  // Hide error message if both are checked
      // Ukloni error message iz URL-a
      const url = new URL(window.location);
      url.searchParams.delete('customer_posted');
      window.history.replaceState({}, '', url);
    }
  }

  hideErrorMessage() {
    const errorMessage = this.element.querySelector('.error_message');
    errorMessage.style.display = 'none';
  }

  popupVisibility(){
    const subscribedKey = sessionStorage.getItem('subscribed');
    if (subscribedKey === 'true'){
      this.element.setAttribute("aria-hidden", false);
    }
  }

  updateNewsletterInput(e) {
    const targetEl = e.target;

    if (targetEl.checked) {
      if (targetEl.value === "men's")
        this.newsletterInput.value = this.newsletterInput.value + ", men's";
      else if (targetEl.value === "women's")
        this.newsletterInput.value = this.newsletterInput.value + ", women's";
    } else {
      if (targetEl.value === "men's")
        this.newsletterInput.value = this.newsletterInput.value.replace(
          ", men's",
          ""
        );
      else if (targetEl.value === "women's")
        this.newsletterInput.value = this.newsletterInput.value.replace(
          ", women's",
          ""
        );
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.style.display = "block";

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", false);
        localStorage.setItem("popup-seen", true);
      })
      
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);
    sessionStorage.setItem('subscribed', 'false');
    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };

  checkForSuccess() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('customer_posted') === 'true') {
      this.element.setAttribute("aria-hidden", false);
      sessionStorage.setItem('subscribed', 'true');
    }
  }
}

customElements.define("newsletter-popup", NewsletterPopup);



class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    if (!this.element.classList.contains("customerPage"))
      this.drawer = new Drawer(this.element.querySelector("#accountDrawer"));
    this.bindEvents();
  }
  bindEvents() {

    this.delegateElement.on(
      "click",
      '[data-action="submit-login"]',
      this.submitLogin.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-recovery"]',
      this.accountRecover.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.accountInputSubmit.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-forgot-pass"]',
      this.accountInputSubmitForgot.bind(this)
    );

  }

  accountInputSubmit(event) {
    if (event.key === "Enter") this.submitLogin(event);
  }

  accountInputSubmitForgot(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.accountRecover(event);
    }
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;
    this.login = this.element.querySelector("#loginFlex");
    this.recover = this.element.querySelector("#recoverFlex");

    if (id == "recoverFlex") {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-hidden", "false");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-hidden", "true");
        
      this.login.querySelectorAll('a, button, input, textarea, select')
        .forEach(el => el.setAttribute('tabindex', '-1'));
      this.recover.querySelectorAll('a, button, input, textarea, select')
        .forEach(el => el.setAttribute('tabindex', '0'));
    } else {
      this.element
        .querySelector("#recoverFlex")
        .setAttribute("aria-hidden", "true");
      this.element
        .querySelector("#loginFlex")
        .setAttribute("aria-hidden", "false");

      this.login.querySelectorAll('a, button, input, textarea, select')
        .forEach(el => el.setAttribute('tabindex', '0'));
      this.recover.querySelectorAll('a, button, input, textarea, select')
        .forEach(el => el.setAttribute('tabindex', '-1'));
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account/recover";

    // Create the request body with the registration data
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    event.target.querySelector(".ButtonText").style.visibility = "hidden";
    event.target.querySelector(".itemLoader").classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML =
            '<span class="pt-m">' +
            tempDiv.querySelector("#RecoverEmail-email-error").innerHTML +
            "</span>";
        } else if(responseText.indexOf('shopify-challenge__container') !== -1) {
          location.href = '/challenge';

        }else if (responseText.indexOf("recoverSuccess") !== -1) {
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--ErrorSpace"
          ).innerHTML = "";
          _this.element.querySelector(
            "#recoverFlex .accountDrawer--SuccessSpace"
          ).innerHTML =
            '<span class="pt-m">' +
            tempDiv.querySelector("#recoverSuccess").innerHTML +
            "</span>";
        }

        event.target.querySelector(".ButtonText").style.visibility = "visible";
        event.target
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      } catch (error) {
        console.log(
          "An error occurred during the registration request:",
          error
        );
      }
    })();
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";

    // Create the request body with the login credentials
    const requestBody = {
      customer: {
        email: this.element.querySelector("#customer_login #CustomerEmail")
          .value,
        password: this.element.querySelector(
          "#customer_login #CustomerPassword"
        ).value,
      },
    };
    const formTarget = event.target.closest('form');
    formTarget.querySelector(".LoginButton .ButtonText").style.visibility = "hidden";
    formTarget.querySelector(".itemLoader").classList.add("is-visible");

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responseText = await response.text();

        if (responseText.indexOf("formError") !== -1) {
          console.log("Incorrect email or password");
          const tempDiv = document.createElement("div");

          tempDiv.innerHTML = responseText;

          _this.element.querySelector(
            "#login .accountDrawer--ErrorSpace"
          ).innerHTML = tempDiv.querySelector(".AlertError").innerHTML;
          formTarget.querySelector(".LoginButton .ButtonText").style.visibility =
            "visible";
            formTarget
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        } else if(responseText.indexOf('shopify-challenge__container') !== -1) {
          location.href = '/challenge';

        } else {
          location.href = window.routes.account_url;
        }
      } catch (error) {
        console.log("An error occurred during the login request:", error);
      }
    })();
  }

}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute("data-settings");

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, additionalOverlay);
        });
      }
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(document.body);

    if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) new RevolutionAnimation(this.element);

    const carouselElement = this.element.querySelector(".swiper");
    new RevolutionSwiper(carouselElement);

    document.documentElement.style.setProperty('--announcement-perma-height', document.body.querySelector('.announcementBar').offsetHeight + 'px');
    this.updateVisibleHeight();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

     
    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-height",
      `${visibleHeight}px`
    );
  }
}
customElements.define("announcement-bar", AnnouncementBar);

class CloseAnnBar extends HTMLElement {
  constructor() {
    super();

    const annBar = document.querySelectorAll(".announcementBar");
    const closeButton = document.querySelectorAll(".AnnouncementBar--Close");

    closeButton.forEach((closeButton) => {
      closeButton.addEventListener("click", (e) => {
        annBar.forEach((annBar) => {
          annBar.classList.add("hidden");
        });

        sessionStorage.setItem("annBarhidden", true);
      });
    });
    if (sessionStorage.getItem("annBarhidden", true)) {
      annBar.forEach((annBar) => {
        annBar.classList.add("hidden");
      });
    }
  }
}

customElements.define("button-close-section", CloseAnnBar);

class ProductCardButtonMobile extends HTMLElement {
  constructor(element) {
    super();
    element ? this.element = element : this.element = this;
    if(this.element.dataset.disable === "true") return;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();

    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {

      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    
      this.button = this.element.querySelector(".cardWrapper--Link");

      this.color = this.element.querySelector(".Color--Wrapper");
      this.cardInformation = this.element.querySelector(
        ".cardInformation--Wrapper"
      );
      this.firstImage = this.element.querySelector(".MainProduct_Image");
      this.secondImage = this.element.querySelector(
        ".ProductCard__Image--secondary"
      );

      this.soldOutCard = this.element.querySelector(
        ".CardInformationSoldOut-Wrapper"
      );
      this.clickCounts = [];
      this.clickState = 0;
      this.bindEvents();
    }

    const newElements = document.querySelectorAll(".cardInformation--Title");
    newElements.forEach((el) => {
      const newEl = el.innerText.replace(/[\n\r]+|[\s]{2,}/g, " ").trim();
      if (newEl.length > 20) {
        el.classList.add("ProductCard--Title");
      }
    });
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="mobile-tap"]',
      this.mobileTap.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-link"]',
      this.openLink.bind(this)
    );

    this.delegateBody.on(
      "touchstart",
      ".productCard",
      this.handleHover.bind(this)
    );

    this.delegateBody.on(
      "touchend",
      ".productCard",
      this.removeHandleHover.bind(this)
    );
  }

  handleHover(event){
    this.productEl = event.target.closest('.productCard');
    this.productEl.classList.add('touch-active');
  }

  removeHandleHover(event){
    this.productEl = event.target.closest('.productCard');
    this.productEl.classList.remove('touch-active');
  }

  mobileTap(event, target) {
    //event.preventDefault();
    const id = event.target.dataset.id;

    this.Card = this.element.querySelector(".cardWrapper--Link");

    if (this.Card.getAttribute("data-state") === "true") {
      window.location.href = target.href;
    } else {
      if (this.Card.getAttribute("data-state") === "false") {
        this.ResetData();
        let cards = document.querySelectorAll(
          ".cardWrapper--Link[data-state='true']"
        );
        cards.forEach((el) => {
          if (el === this.element) {
            return el.setAttribute("data-state", "true");
          }
          el.setAttribute("data-state", "false");
        });
      }
      this.handleHoverState();
      this.Card.setAttribute("data-state", "true");
    }
  }

  openLink(event, target) {
    event.preventDefault();
    let dataHref = target.getAttribute("data-href");
    window.location.href = dataHref;
  }

  ResetData() {
    let buttons = document.querySelectorAll(".cardInformation--Wrapper");
    buttons.forEach((el) => {
      el.classList.remove("is-hidden");
    });

    let soldOutwrapper = document.querySelectorAll(
      ".CardInformationSoldOut-Wrapper"
    );
    soldOutwrapper.forEach((el) => {
      el.classList.remove("is-visible");
    });

    let sizes = document.querySelectorAll(".Size--Wrapper");
    sizes.forEach((el) => {
      el.classList.remove("is-visible");
    });

    let colors = document.querySelectorAll(".new-Colors-div");
    colors.forEach((el) => {
      el.classList.remove("is-visible");
    });

    let colorNumbers = document.querySelectorAll(".Number-div");
    colorNumbers.forEach((el) => {
      el.classList.remove("is-visible");
    });

    let images_one = document.querySelectorAll(".MainProduct_Image");
    images_one.forEach((el) => {
      el.classList.remove("is-hidden");
    });

    let images_two = document.querySelectorAll(
      ".ProductCard__Image--secondary"
    );
    images_two.forEach((el) => {
      el.classList.remove("is-visible");
    });
  }

  handleHoverState() {
    this.cardInformation.classList.add("is-hidden");
    if (this.soldOutCard) {
      this.soldOutCard.classList.add("is-visible");
    }

    //div for number of NOT displayed colors below product
    if (!this.element.querySelector(".Number-div")) {
      if (this.color) {
        let oldarr = [...this.color.children].slice(
          3,
          [...this.color.children].length
        );

        let newNumberDiv = document.createElement("div");
        newNumberDiv.innerText = "+" + oldarr.length;
        if (oldarr.length === 0) {
          newNumberDiv.innerText = "";
        }
        this.color.appendChild(newNumberDiv);
        newNumberDiv.classList.add("Number-div", "is-visible");
      }
    }

    if(this.element.querySelector('.Size--Wrapper')){
      this.element.querySelector('.Size--Wrapper').classList.add('is-visible');
    }

    //div for 3 colors displayed below product
    if (!this.element.querySelector(".new-Colors-div")) {
      let newDiv = document.createElement("div");
      newDiv.classList.add("new-Colors-div", "is-visible");
      if (this.color) {
        let newarr = [...this.color.children].slice(0, 3);
        newarr.forEach((el) => {
          el.classList.add("is-visible");
          newDiv.appendChild(el);
        });
        this.color.appendChild(newDiv);
      }
    }

    this.colorwrapper = this.element.querySelector(".new-Colors-div");
    if (this.colorwrapper) {
      this.colorwrapper.classList.add("is-visible");
    }
    this.numberWrapper = this.element.querySelector(".Number-div");
    if (this.numberWrapper) {
      this.numberWrapper.classList.add("is-visible");
    }
    this.firstImage.classList.add("is-hidden");

    if (this.secondImage) {
      this.secondImage.classList.add("is-visible");
    } else {
      this.firstImage.classList.remove("is-hidden");
    }
  }
}

customElements.define("mobile-button-handler", ProductCardButtonMobile);


class StoreLocation extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.selectbox = this.element.querySelector(".RevolutionSelectbox");
    new RevolutionSelectbox(this.selectbox);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="selectbox-change"]',
      this.showAppropriateLocations.bind(this)
    );
    document.addEventListener("DOMContentLoaded", () =>
      setTimeout(this.setSelectboxHeight.bind(this), 500)
    );
  }

  setSelectboxHeight() {
    const selectboxContent = this.selectbox.querySelector(
      ".RevolutionSelectbox--Content"
    );
    const selectBoxButtonHeight = this.selectbox.offsetHeight;
    const locationWrapperHeight = parseInt(
      getComputedStyle(this.element.querySelector(".Location--Wrapper")).height
    );


    selectboxContent.style.maxHeight =
      locationWrapperHeight - selectBoxButtonHeight + "px";
  }

  showAppropriateLocations(e) {
    this.element
      .querySelectorAll(".Location--StoreWrapper")
      .forEach((store) => {
        store.style.display = "block";
        if (
          e.target.getAttribute("data-value") === window.languages.locationAll
        )
          return;
        if (
          store.getAttribute("data-id") != e.target.getAttribute("data-value")
        ) {
          store.style.display = "none";
        }
      });
  }
}
customElements.define("store-location", StoreLocation);

if (document.querySelector(".FriendReferral")) {
  var con = document.getElementById("conjured_referral");
  if (!con) con = document.getElementById("conjured_redemption");

  if (con) {
    appendCustomStylesheet();
    const intervalId = setInterval(function () {
      if (checkHeadForConjuredStyles()) {
        clearInterval(intervalId);
      }
    }, 5);
    setTimeout(() => {
      if (intervalId) clearInterval(intervalId);
    }, 7500);

    const pageTitle = document.querySelector(".PageTitle");
    if (pageTitle) pageTitle.remove();
  }

  function checkHeadForConjuredStyles() {
    var headStyles = document.head.querySelectorAll("style");
    var removed = false;

    headStyles.forEach(function (styleElement) {
      var styleContent = styleElement.textContent || styleElement.innerText;

      if (
        styleContent.includes("conjured_referral") ||
        styleContent.includes("conjured_redemption")
      ) {
        styleElement.remove();
        removed = true;
      }
    });

    return removed;
  }

  function appendCustomStylesheet() {
    const stylesheetURL = document.querySelector(".FriendReferral").innerHTML;
    var stylesheetLink = document.createElement("link");

    stylesheetLink.rel = "stylesheet";
    stylesheetLink.href = stylesheetURL;
    stylesheetLink.media = "print";

    stylesheetLink.onload = function () {
      this.media = "all";
    };

    document.head.appendChild(stylesheetLink);
  }
}

class BlogItemComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.BlogItemDelegate = new Delegate(this.element);
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
    }
    const textElement = this.element.querySelector(".BlogItem--Header");

    if (textElement.innerText.length > 20) {
      textElement.classList.add("BlogItem--Title");
    }

    
    this.handleBlogItem();
    this.handleBlogListener = this.handleBlogItem.bind(this);
    window.addEventListener('resize', this.handleBlogListener);
  }

  handleBlogItem() {
    const textElement = this.element.querySelector(".Article-Content");
    if (!textElement) return;
  
    const textRect = textElement.getBoundingClientRect();
    const elementHeight = textRect.height;

    let fade = document.createElement('div');
    fade.classList.add("BlogItem--fade");
      
    if (elementHeight > 3 * parseFloat(getComputedStyle(textElement).lineHeight)) {
      // Truncate text to 3 rows and add ellipsis
      const lineHeight = parseFloat(getComputedStyle(textElement).lineHeight);
      textElement.style.maxHeight = `${3 * lineHeight}px`;
      textElement.style.overflow = "hidden";1
      textElement.append(fade);
    }
  }
  
}
customElements.define("blog-item-component", BlogItemComponent);

class OtherPagesTables extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    const progressBar = this.querySelector(".tablePagination");
    const tableContent = this.querySelector(".sizeGuideInner--tableContent");
    const progressBarWrapper = this.querySelector(".tablePagination--wrapper");

    // Initial width for the progress bar (adjust as needed)
    let initialWidth =
      (tableContent.clientWidth / tableContent.scrollWidth) * 100; //  initial width

    // Set initial width for progress bar

    progressBar.style.width = `${initialWidth}%`;
    if (tableContent.clientWidth >= tableContent.scrollWidth) {
      progressBarWrapper.classList.add("remove");
    } else {
      progressBarWrapper.classList.remove("remove");

      // Add scroll event listener to update the progress bar width
      tableContent.addEventListener("scroll", () => {
        const scrollPercentage =
          (tableContent.scrollLeft /
            (tableContent.scrollWidth - tableContent.clientWidth)) *
          100;

        const newWidth = Math.max(initialWidth, scrollPercentage);
        progressBar.style.width = `${newWidth}%`;
      });
    }

    this.bindEvents();
  }

  bindEvents() {
    let mouseDown = false;
    let startX, scrollLeft;
    const slider = this.element.querySelector(".sizeGuideInner--tableContent ");

    const startDragging = (e) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const stopDragging = (e) => {
      mouseDown = false;
    };

    const move = (e) => {
      e.preventDefault();
      if (!mouseDown) {
        return;
      }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    };



    let _this = this;
    document.addEventListener("DOMContentLoaded", () => {
        //reset scrolled table
        const slider = _this.element.querySelectorAll(
          ".sizeGuideInner--tableContent "
        );

        slider.forEach((table) => {
          table.scrollLeft = 0;
        });
      
    });

    slider.addEventListener("mousemove", move, false);
    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("mouseleave", stopDragging, false);
  }
}
customElements.define("table-pages-content", OtherPagesTables);

class OtherPagesSwiper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    if(this.breakpoint === 'phone' || this.breakpoint === "tablet"){
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    }


  }


}
customElements.define("small-menu-swiper", OtherPagesSwiper);


class SubscriptionFlow extends HTMLElement {
  constructor(element) {
    super();
    element ? (this.element = element) : (this.element = this);
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.quantityButton = document.querySelector(".QuantityHandler");
    

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="subscription-change"]',
      this.toggleSubscription.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="subscribe-enter"]',
      this.enterSubscription.bind(this)
    );

   
  }

  enterSubscription(e){

    this.sellingPlanInput = document.querySelector("#selling_plan");
    this.choosenPlan = this.element.querySelector('.Product--SubscriptionButton[aria-selected="true"');
    this.choosenPlan?this.sellingPlanInput.value = this.choosenPlan.dataset.plan:this.sellingPlanInput.value = "";

    const htmlString = `
  <div data-shopify="payment-button" data-has-selling-plan="true" data-has-fixed-selling-plan="false" data-customer-accounts-required="false" class="shopify-payment-button u-p2">
    <button class="shopify-payment-button__button shopify-payment-button__button--unbranded shopify-payment-button__button--hidden" disabled="disabled" aria-hidden="true">&nbsp;</button>
    <button class="shopify-payment-button__more-options shopify-payment-button__button--hidden" disabled="disabled" aria-hidden="true">&nbsp;</button>
  </div>
`;

    e.preventDefault();
    let currentVariant = window.location.search.split('variant=')[1];
    let choosenPlan = this.choosenPlan.getAttribute('data-plan');
  
      fetch(window.routes.localeRootUrl + "/cart/add.js", {
        body: JSON.stringify({
          id: currentVariant,
          quantity: 1,
          selling_plan: choosenPlan,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
        },
      })
      .then(response => {
        if (response.ok) {
          this.element.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: currentVariant,
                quantity: 1,
              },
            })
          );
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });


    const payNow = document.querySelector('.productForm--aditionalCheckoutButtons');
    if(payNow){
      payNow.innerHTML = htmlString;
      this.handleExpressButtons();
    }

    

      
    
  }

  //toggles between selected subscription
  toggleSubscription(e) {
    e.preventDefault();

    const oneTimeButton = this.element.querySelector(
      ".Product--SubscriptionOneTimeButton"
    );
    const subscriptionButton = this.element.querySelector(
      ".Product--SubscriptionButton[aria-selected='true']"
    );

    if (!oneTimeButton && !subscriptionButton) return;

    const parentElement = e.target.closest(".Product--SubscriptionOption");

    this.element.dispatchEvent(
      new CustomEvent("price:change", {
        bubbles: true,
        detail: {
          eventName: "subs",
          price: parentElement.querySelector("[data-price]").dataset.price,
        },
      })
    );

    if (parentElement.dataset.value === "one_time") {
     
      oneTimeButton.setAttribute("aria-selected", "true");
      if (subscriptionButton)
        subscriptionButton.setAttribute("aria-selected", "false");
    } else if (parentElement.dataset.value !== "one_time") {
     
      if (subscriptionButton) {
        subscriptionButton.setAttribute("aria-selected", "false");
      }
      oneTimeButton.setAttribute("aria-selected", "false");
      parentElement.setAttribute("aria-selected", "true");
    }
  }
}

customElements.define("subscription-flow", SubscriptionFlow);


let handleCartExpress = false;

class cartPage extends HTMLElement {
  constructor() {
    super();
    this.element = this;
   
    if(handleExpress == false) {
      this.handleExpressButtons();
      handleExpress = true;
    }

    this.buttonsCheck();
  }

  
  buttonsCheck(){
    let cartProducts = this.element.querySelectorAll('.cartItem:not([data-gift-bag-item]):not([data-bag-item])');
    let atcButton = this.element.querySelector('.CartFooter--Buttons .Button');
    let checkoutBtn = this.element.querySelector('.dynamicCheckout');

    atcButton?.setAttribute('disabled', true);
    checkoutBtn?.setAttribute('disabled', true);

    if(cartProducts.length > 0){
      atcButton?.removeAttribute('disabled');
      checkoutBtn?.removeAttribute('disabled');
    } 

    const msgWrap = document.querySelector('.incopatible_message');
    if (document.querySelector('[data-incompatabile="true"]') && msgWrap && document.querySelector('[data-gift="true"]')){
      msgWrap.style.display ="block";
    } else if(msgWrap) {
      msgWrap.style.display = "none";
    }
  }


  handleExpressButtons() {
    let observer;
    const observerCallback = (mutations) => {

        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('[data-shopify-buttoncontainer]') || this.element.querySelector('#dynamic-checkout-cart undefined')) {
                  const applePay = this.element.querySelector('[data-testid="ApplePay-button"]');
                  if (applePay) {
                    const containerElement = applePay.parentElement; // Assuming applePay is a direct child of the container
                    const parentContainer = containerElement.parentElement;
                    containerElement.style.cssText = "display: block !important;";
                    const allPayment = parentContainer.querySelectorAll('li');
                    allPayment.forEach((item) => {

                      if(item != containerElement){
                        item.style.display = "none";
                      }
                    })
                  }
                  if (node.querySelector('undefined') || this.element.querySelector('#dynamic-checkout-cart undefined')){

        
                    const textEl = this.element.querySelector('#dynamic-checkout-cart undefined');

                    if (textEl) {
                        const text = textEl.textContent;
                        const div = document.createElement('div');
                        div.innerText = text;
                        div.classList.add('CartFooter--ButtonText');
                        div.classList.add('u-p2');
                      
                        textEl.style.display = "none";
                        if(document.querySelector('.CartFooter--ButtonText'))return;
                        document.querySelector('.CartFooter--ButtonBox').append(div);
                    }
                  } else if(node && document.querySelector('.CartFooter--ButtonText')){
                    document.querySelector('.CartFooter--ButtonText').remove();
                  }

            
                }else if(node && document.querySelector('.CartFooter--ButtonText')){
                  document.querySelector('.CartFooter--ButtonText').remove();
                }
         
            });
        });
    };

    const observerOptions = { childList: true, subtree: true };
    const buttonBox = document.querySelector('#dynamic-checkout-cart');

    if (buttonBox) {

        observer = new MutationObserver(observerCallback);
        observer.observe(buttonBox, observerOptions);
    }
}

}

customElements.define("cart-page", cartPage);

class CartSwimbagDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.swim_bagDrawer = new Drawer(this.element);
    //new AddToCart(this.element);
    const idElem = this.element.querySelector("input[data-productid]");
    if (idElem) {
      const id = idElem.value;
      new AddToCart(this.element, id);
    } else {
      new AddToCart(this.element);
    }
    this.bindEvents();
  }
  bindEvents() {
    this.closeListener = this.swim_bagDrawer.closeDrawer();
    this.element
      .querySelector('[data-action_giftwrapper="close_drawer"]')
      .addEventListener(
        "click",
        this.closeListener
      );
  }
}

customElements.define("cart-swimbag-drawer", CartSwimbagDrawer);

class NewsletterSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegate = new Delegate(this.element);
    this.newsletterInputs = this.element.querySelectorAll("#CustomerNewsletter-form");

    this.form = this.element.querySelector('#newsletterForm');
   
    const mensCheckbox = this.element.querySelector('#mensCheckboxS');
    const womensCheckbox = this.element.querySelector('#womensCheckboxS');
    const emailInput = this.element.querySelector('input[name="contact[email]"]');

    // Dodaj eventListener za svaki checkbox ako postoji
    if (mensCheckbox) {
      mensCheckbox.addEventListener('change', this.hideErrorMessage.bind(this));
    }
    if (womensCheckbox) {
      womensCheckbox.addEventListener('change', this.hideErrorMessage.bind(this));
    }
    if (emailInput) {
      emailInput.addEventListener('change', this.hideErrorMessage.bind(this));
    }

  }

  connectedCallback() {
    this.delegateElement.on(
      "change",
      '[data-action="update-newsletter"]',
      this.updateNewsletterInput.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="submit-form"]',
      this.handleFormSubmit.bind(this)
    );
    this.delegate.on(
      'keypress',
      '[data-action="submit-form"]', 
      this.handleFormSubmit.bind(this));
  }

  updateNewsletterInput(e) {
    const targetEl = e.target;

    if (targetEl.checked) {
      if (targetEl.value === "men's")
      this.newsletterInputs.forEach(input => input.value = input.value + ", men's");
      else if (targetEl.value === "women's")
      this.newsletterInputs.forEach(input => input.value = input.value + ", women's");
    } else {
      if (targetEl.value === "men's")
        this.newsletterInputs.forEach(input => input.value = input.value.replace(
          ", men's",
          ""
        ));
      else if (targetEl.value === "women's")
        this.newsletterInputs.forEach(input => input.value = input.value.replace(
          ", women's",
          ""
        ));
    }
  }

  async handleFormSubmit(event) {
    if (event instanceof KeyboardEvent && event.key !== "Enter") return;

    const mensCheckbox = this.element.querySelector('#mensCheckboxS');
    const womensCheckbox = this.element.querySelector('#womensCheckboxS');
    const errorMessage = this.element.querySelector('.error_messageS');
    const emailInput = this.element.querySelector('input[name="contact[email]"]');
    const allertError = this.element.querySelector('.AlertError');

    event.preventDefault();

    if (emailInput.value.trim() === '') {
        allertError.style.display = 'block';
        return; // Zaustavi dalje izvršavanje ako email nije unet
    }
    if (mensCheckbox || womensCheckbox) {
      if (!mensCheckbox.checked && !womensCheckbox.checked) {
        errorMessage.style.display = 'block';
        return; // Zaustavi dalje izvršavanje ako nijedan checkbox nije označen
      }
    }

    allertError.style.display = 'none';
    errorMessage.style.display = 'none';
    const email = this.element.querySelector('#email__input').value;

    const listId = this.element.dataset.klaviyoListId;
    const source = "section";

    await subscribeToKlaviyo(email, listId, source);
    this.form.submit();    
  }

  hideErrorMessage() {
    const errorMessage = this.element.querySelector('.error_messageS');
    const allertError = this.element.querySelector('.AlertError');
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
    if (allertError){
      allertError.style.display = 'none';
    }
  }
}

customElements.define("newsletter-section", NewsletterSection);

class SubscriptionDropdown extends HTMLElement {
  static observedAttributes = ["data-variant-price"];

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);    
  }

  connectedCallback() {
    this.delegateElement.on(
      "click",
      '[data-action="select-plan"]',
      this.selectPlan.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-sub-dropdown"]',
      this.toggleDropdown.bind(this)
    );

    this.delegateElement.on(
      "focusin",
      '[data-action="toggle-sub-dropdown"]',
      this.toggleDropdown.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-sub-drawer"]',
      this.openDrawer.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="close-sub-drawer"]',
      this.closeDrawer.bind(this)
    );
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == "data-variant-price") this.variantPriceChanged(newValue);
  }

  variantPriceChanged(newValue) {
    const priceElem = this.element.querySelector(".subscription-dropdown__heading-price");
    priceElem.dataset.price = newValue;

    const plan = this.element.querySelector('.subscription-dropdown__selling-plan[aria-selected="true"]') || null; 
    this.updateSubPrice(plan);
  }

  toggleDropdown() {       
    const target = event.target.closest('[data-action]');
    if (!target || target.dataset.action !== "toggle-sub-dropdown") return;

    if (event.type === "focusin" && target === document.activeElement) {
      return;
    }

    event.stopPropagation();

    const expand = target.getAttribute("aria-expanded") === "true" ? false : true;
    if (expand) this.openDropdown();
    else {
      this.closeDropdown();
      
        this.element.dispatchEvent(
          new CustomEvent("subscription:dropdown:close", {
            bubbles: true,
          })
        );
    
    }
    setTimeout(() => {
      this.element.dispatchEvent(
        new CustomEvent("element:size:change", {
          bubbles: true,
        })
      );
    }, 200)
  }

  openDropdown() {
    requestAnimationFrame(()=>{
      this.element.setAttribute("aria-expanded", true);
      this.element.classList.add("is-open");
    });
    const preselect = this.element.querySelector('.subscription-dropdown__selling-plan[aria-selected="true"]');
    preselect?.click();

    const desktop = new Responsive().matchesBreakpoint("lap-and-up");
    if (!desktop) this.scrollToElement();
  }

  scrollToElement() {
    const header = document.querySelector(".header--Sticky");
    const stickyAtc = document.querySelector(".main-product__mobile-sticky-atc");

    const headerOffset = header?.getBoundingClientRect().height || 0;
    const offset = (stickyAtc?.getBoundingClientRect().height || 0) + 2;

    const rect = this.element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const elementTop = rect.top - headerOffset;
    const elementBottomWithOffset = rect.bottom + offset;
    const scrollY = window.scrollY || window.pageYOffset;

    let targetPosition = null;
    
    if (elementBottomWithOffset > viewportHeight) {
      targetPosition = scrollY + rect.top - viewportHeight + rect.height + offset;

    } else if (elementTop < 0) {
      targetPosition = scrollY + elementTop;
    }    

    if (!targetPosition) return;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  closeDropdown() {
    this.element.setAttribute("aria-expanded", false);
    setTimeout(()=>{
      this.element.classList.remove("is-open");
    },200);
    const subId = "";

    this.updateSubInput(subId);
    this.updateButtonPrice();
  }

  selectPlan() {
    const target = event.target.closest('[data-action="select-plan"]');
    if (!target) return;

    const oldSub = this.element.querySelector('[data-action="select-plan"][aria-selected="true"]');
    oldSub?.setAttribute("aria-selected", false);

    const subId = target.dataset.subId;
    this.element.dataset.subId = subId;

    this.updateSubInput(subId);
    this.updateSubPrice(target);
    this.updateButtonPrice(target);

    target.setAttribute("aria-selected", "true");
  }

  updateSubInput(id) {
    const subInput = document.querySelector("#selling_plan");
    if (!subInput) return;

    subInput.value = id;
  }

  updateSubPrice(plan) {
    let discount = plan?.dataset.discount || 0;

    const priceElem = this.element.querySelector(".subscription-dropdown__heading-price");
    let price = Number(priceElem.dataset.price);

    const compareElem = this.element.querySelector(".subscription-dropdown__heading-compare-price");
    let compare = Number(compareElem.dataset.compare);

    if (discount) {
      discount = Number(discount) / 100;
      price = price - (price * discount);
    }

    let newPrice = Shopify.formatMoney(price);
    newPrice = newPrice.replace(/,/g, "");
    priceElem.innerHTML = newPrice;
        
    if (compare > price) compareElem.innerHTML = Shopify.formatMoney(compare).replace(/,/g, "");
    else compareElem.innerHTML = "";
  }

  updateButtonPrice(plan) {
    let discount = plan?.dataset.discount || 0;
    const priceElem = this.element.querySelector(".subscription-dropdown__heading-price");
    let price = Number(priceElem.dataset.price);

    if (discount) {
      discount = Number(discount) / 100;
      price = price - (price * discount);
    }

    const newPrice = Shopify.formatMoney(price);

    const buttons = document.querySelectorAll('product-component [data-action="add-to-cart"], product-component [data-action="open-sizepicker"]');
    buttons.forEach(button => {
      const priceElem = button.querySelector(".mainProductBtn--price");
      if (priceElem) priceElem.innerHTML = newPrice;
    })
  }

  openDrawer() {
    const drawer = document.querySelector("#subscription-dropdown__drawer");
    if (!drawer) return;

    drawer.setAttribute("aria-hidden", false);
    bodyScrollLock.disableBodyScroll(drawer);

    const overlay = document.querySelector(".pageOverlay");

    if (!overlay) return;

    overlay.classList.add("is-visible");
    this.overlayEventFunction = this.closeDrawer.bind(this);
    overlay.addEventListener("click", this.overlayEventFunction)
  }

  closeDrawer() {    
    const drawer = document.querySelector("#subscription-dropdown__drawer");
    if (!drawer) return;

    drawer.setAttribute("aria-hidden", true);
    bodyScrollLock.clearAllBodyScrollLocks();

    const overlay = document.querySelector(".pageOverlay");

    if (!overlay) return;

    overlay.classList.remove("is-visible");
    overlay.removeEventListener("click", this.overlayEventFunction)
  }
}

customElements.define("subscription-dropdown", SubscriptionDropdown);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (
      window.theme.enableImageAnimations ||
      window.theme.enableTextAnimations
    ) {
      new RevolutionAnimation(this.element);
    }
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.delegate = new Delegate(this.element);
  }

  connectedCallback() {
    const desktop = new Responsive().matchesBreakpoint("lap-and-up");
    if (!desktop) return;

    const slides = this.element.querySelectorAll(".usps-slide");
    slides.forEach(elem => {
      elem.addEventListener("mouseenter", this.handleMouseOver.bind(this));
      elem.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
    })
  }

  handleMouseOver(event) {
    const slide = event.target.closest(".usps-slide");
    if (!slide) return;

    const text = slide.querySelector(".usp__text");
    if (!text) return;

    const dummyText = slide.querySelector(".usp__dummy-text");

    text.style.height = dummyText.offsetHeight + "px";
    text.setAttribute("aria-hidden", "false");
  }

  handleMouseLeave(event) {
    const slide = event.target.closest(".usps-slide");
    if (!slide) return;

    const text = slide.querySelector(".usp__text");
    if (!text) return;

    text.setAttribute("aria-hidden", "true");
    text.style.height = "0px";
  }
}
customElements.define("usp-section", UspSection);

async function subscribeToKlaviyo(email, listId, source) {
  try {
    if (!listId || !email) throw "Data missing - " + "list id: " + listId + " email: " + email;

    // pass in additional fields, each additional field
    // must be included in the $fields string separated by commas
    //"$fields": "$message, $first_name, $last_name",
    // https://community.klaviyo.com/developer-group-64/how-to-use-form-element-to-post-member-to-a-list-4126

    const settings = new URLSearchParams({
      g: listId,
      $fields: "$source",
      email: email,
      $source: source || "section"
    })

    const url = `https://manage.kmail-lists.com/ajax/subscriptions/subscribe`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache",
      },
      body: settings.toString()
    });

    if (!response.ok) throw response;

    const reponseBody = await response.json();
    if (!reponseBody.success) {
      console.error("Subscription not successful:", reponseBody.errors);
      return false;
    }

    return true;

  } catch (error) {
    console.error("Error occurred during subscription creation:", error);
    return false;
  }
}

class ShopBy extends HTMLElement {
  static normalizePathname(pathname) {
    const path = pathname.replace(/\/$/, '');
    return path || '/';
  }

  static updateAllInstances() {
    document.querySelectorAll('shop-by').forEach((shopBy) => {
      shopBy.setActiveButtons();
      shopBy.scrollToActiveButton();
    });
  }

  constructor() {
    super();
    this.element = this;
    this.carousel = new RevolutionSwiper(this.querySelector('.swiper'));
    this.delegate = new Delegate(this);
    this.onCollectionRenderedBound = this.onCollectionRendered.bind(this);
    this.onCollectionNavigateBound = this.onCollectionNavigate.bind(this);

    this.classList.add('shop-by--instant-text');
    this.setActiveButtons({ animate: false });
    this.scrollToActiveButton();
    requestAnimationFrame(() => this.classList.remove('shop-by--instant-text'));

    this.delegate.on('click', '.simple__button.shop-by__button-slide a', this.handleShopByClick.bind(this));
    }

  connectedCallback() {
    document.addEventListener('collection:rendered', this.onCollectionRenderedBound);
    document.addEventListener('collection:navigate', this.onCollectionNavigateBound);

    if (this.dataset.animation !== 'true') return;
    if (!new Responsive().matchesBreakpoint('lap-and-up')) return;

    this.delegate.on('mouseover', '.shop-by__slide', this.handleMouseEnter.bind(this));
    this.delegate.on('mouseout', '.shop-by__slide', this.handleMouseLeave.bind(this));
  }

  disconnectedCallback() {
    this.delegate.destroy();
    document.removeEventListener('collection:rendered', this.onCollectionRenderedBound);
    document.removeEventListener('collection:navigate', this.onCollectionNavigateBound);
  }

  onCollectionRendered(event) {
    this.setActiveButtons();
    this.scrollToActiveButton();
  }

  onCollectionNavigate() {
    queueMicrotask(() => {
      this.setActiveButtons();
      this.scrollToActiveButton();
    });
  }

  handleShopByClick(event) {
    const linkEl = event.target.closest('a');
    if (!linkEl) return;

    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const hasAsyncCollectionGrid = document.querySelector('collection-filters-form') && document.getElementById('filterSection');
    if (!hasAsyncCollectionGrid) return;

    event.preventDefault();

    const url = new URL(linkEl.href, window.location.origin);
    const pathname = url.pathname;
    // Important: a bare collection URL (no query params) should reset filters/sort.
    // So we DO NOT fall back to the current window.location.search here.
    const searchParams = url.searchParams.toString();

    document.dispatchEvent(
      new CustomEvent('collection:navigate', {
        detail: { pathname, searchParams },
      })
    );

    // `collection:navigate` is handled synchronously and will pushState immediately,
    // so we can update active UI state right away (no need to wait for fetch).
    ShopBy.updateAllInstances();
  }

  handleMouseEnter(event) {
    const slide = event.target.closest('.shop-by__slide');
    const text = slide.querySelector('.shop-by__collection-text');
    if (!text) return;

    text.style.height = slide.querySelector('.usp__dummy-text').offsetHeight + 'px';
    text.setAttribute('aria-hidden', 'false');
  }

  handleMouseLeave(event) {
    const slide = event.target.closest('.shop-by__slide');
    if (!slide) return;
    if (slide.contains(event.relatedTarget)) return;

    const text = slide.querySelector('.shop-by__collection-text');
    if (!text) return;
    if (slide.getAttribute('aria-selected') === 'true') return;

    text.style.height = '0px';
    text.setAttribute('aria-hidden', 'true');
  }

  shouldAnimateSlideText() {
    return this.dataset.animation === 'true' && new Responsive().matchesBreakpoint('lap-and-up');
  }

  updateSlideTextHeights(slides, animate = true) {
    if (!this.shouldAnimateSlideText()) return;

    const applyHeights = () => {
      slides.forEach((slide) => {
        const text = slide.querySelector('.shop-by__collection-text');
        const dummyText = slide.querySelector('.usp__dummy-text');
        if (!text || !dummyText) return;

        const isSelected = slide.getAttribute('aria-selected') === 'true';
        const isHovered = slide.matches(':hover');
        const targetHeight = isSelected || isHovered ? dummyText.offsetHeight : 0;

        text.style.height = targetHeight + 'px';
        text.setAttribute('aria-hidden', isHovered ? 'false' : 'true');
      });
    };

    if (animate) {
      requestAnimationFrame(applyHeights);
    } else {
      applyHeights();
    }
  }

  setActiveButtons({ animate = true } = {}) {
    const ignoredParams = new Set(['sort_by', 'page']);
    const normalizePathname = ShopBy.normalizePathname;
    const getComparableValues = (url, key) => url.searchParams.getAll(key).sort();
    const valuesMatch = (url, currentUrl, key) => {
      const linkValues = getComparableValues(url, key);
      const currentValues = getComparableValues(currentUrl, key);

      return linkValues.length === currentValues.length && linkValues.every((value, index) => value === currentValues[index]);
    };

    const getFilterKeysFromUrl = (url) => {
      const filterKeys = [];
      url.searchParams.forEach((value, key) => {
        if (!ignoredParams.has(key)) filterKeys.push(key);
      });
      return filterKeys;
    };

    const getSectionFilterKeys = (buttons) => {
      const filterKeys = new Set();
      buttons.forEach((button) => {
        getFilterKeysFromUrl(new URL(button.href, window.location.origin)).forEach((key) => filterKeys.add(key));
      });
      return filterKeys;
    };

    const checkIfButtonIsActive = (href, sectionFilterKeys) => {
      const url = new URL(href, window.location.origin);
      const currentUrl = new URL(window.location.href);
      if (normalizePathname(url.pathname) !== normalizePathname(currentUrl.pathname)) return false;

      const buttonFilterKeys = getFilterKeysFromUrl(url);
      if (!buttonFilterKeys.length) {
        return [...sectionFilterKeys].every((key) => !currentUrl.searchParams.has(key));
      }

      return buttonFilterKeys.every((key) => valuesMatch(url, currentUrl, key));
    };

    const checkIfSlideIsActive = (href) => {
      const url = new URL(href, window.location.origin);
      const currentUrl = new URL(window.location.href);
      if (normalizePathname(url.pathname) !== normalizePathname(currentUrl.pathname)) return false;
      if (!url.search) return true;
      return url.search === currentUrl.search;
    };

    const buttons = this.element.querySelectorAll('.simple__button a');
    const sectionFilterKeys = getSectionFilterKeys(buttons);
    buttons.forEach((button) => {
      button.removeAttribute('aria-selected');
      if (checkIfButtonIsActive(button.href, sectionFilterKeys)) {
        button.setAttribute('aria-selected', true);
      }
    });

    const slides = this.element.querySelectorAll('.shop-by__slide');

    if (animate && this.shouldAnimateSlideText()) {
      slides.forEach((slide) => {
        const text = slide.querySelector('.shop-by__collection-text');
        if (text) text.style.height = text.offsetHeight + 'px';
      });
    }

    slides.forEach((slide) => {
      slide.removeAttribute('aria-selected');
      const slideLink = slide.querySelector('a');
      if (slideLink && checkIfSlideIsActive(slideLink.href)) {
        slide.setAttribute('aria-selected', 'true');
      }
    });

    this.updateSlideTextHeights(slides, animate);
  }

  scrollToActiveButton() {    
    const firstActive = this.element.querySelector('.simple__button:has(a[aria-selected="true"])') || this.element.querySelector('.shop-by__slide[aria-selected="true"]');
    if (!firstActive) return;

    if (firstActive.classList.contains('swiper-slide-active')) return;    

    const label = firstActive.getAttribute("aria-label").split("/");
    const index = Number(label[0]) - 1;    
    
    this.carousel.swiperElement.slideTo(index);
  }

}

customElements.define('shop-by', ShopBy);


class VideoObserver {
  static observer = null;
  static rootMargin = '200px 0px 200px 0px';
  static threshold = 0;

  static init() {
    if (VideoObserver.observer) return;
    VideoObserver.observer = new IntersectionObserver(VideoObserver.handleIntersect, {
      rootMargin: VideoObserver.rootMargin,
      threshold: VideoObserver.threshold
    });
  }

  static handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      VideoObserver.observer.unobserve(entry.target);
      entry.target.dispatchEvent(new CustomEvent('video:visible', { bubbles: true }));
    });
  }

  constructor(element) {
    VideoObserver.init();
    this.element = element;
    VideoObserver.observer.observe(this.element);
  }
}

class Html5VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.videoElement = this.element.querySelector('video');
    this.syncStateFromVideoBound = this.syncStateFromVideo.bind(this);

    this.delegateElement.on('play', '.html5-video__video', this.syncStateFromVideoBound);
    this.delegateElement.on('pause', '.html5-video__video', this.syncStateFromVideoBound);
    this.delegateElement.on('volumechange', '.html5-video__video', this.syncStateFromVideoBound);
    this.syncStateFromVideo();

    this.delegateElement.on('click', '[data-action="toggle-play"]', this.handleTogglePlay.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-mute"]', this.handleToggleMute.bind(this));

    if (this.element.dataset.videoLoad === 'scroll') {
      this.bindVideoScrollLoad = this.handleVideoScrollLoad.bind(this);

      this.delegateElement.on('video:visible', 'html5-video-player', this.handleVideoObserverVisibleBound);

      this.videoObserver = new VideoObserver(this.element);
    } else if (this.element.dataset.videoLoad === 'first-interaction') {

      this.bindVideoFirstInteractionLoad = this.handleVideoFirstInteractionLoad.bind(this);

      this.firstInteractionObserver = new PerformanceObserver(() => {
        this.handleVideoFirstInteractionLoad();
      });
      
      this.firstInteractionObserver.observe({ type: 'first-input' });

      requestAnimationFrame(() => {
        window.addEventListener('scroll', this.bindVideoFirstInteractionLoad, { once: true, passive: true });
        window.addEventListener('mousemove', this.bindVideoFirstInteractionLoad, { once: true, passive: true });
      });
    }
  }

  disconnectedCallback() {
    this.cleanupFirstInteraction();
    this.delegateElement.destroy();
  }

  handleVideoScrollLoad(event, trigger) {
    this.loadVideo();

    this.delegateElement.off('video:visible', 'html5-video-player', this.handleVideoObserverVisibleBound);
  }

  handleVideoFirstInteractionLoad() {
    this.loadVideo();
    this.cleanupFirstInteraction();
  }

  cleanupFirstInteraction() {
    if (this.firstInteractionObserver) {
      this.firstInteractionObserver.disconnect();
      this.firstInteractionObserver = null;
    }
    window.removeEventListener('scroll', this.bindVideoFirstInteractionLoad);
    window.removeEventListener('mousemove', this.bindVideoFirstInteractionLoad);
  }

  loadVideo() {
    const template = this.element.querySelector('template[data-video-sources]');
    if (!template || !this.videoElement) return;

    while (template.content.firstChild) {
      this.videoElement.appendChild(template.content.firstChild);
    }

    template.remove();
    this.videoElement.load();

    if (this.element.dataset.autoplay === 'true') {
      this.element.dataset.videoState = 'playing';
      this.handleLazyAutoplayBound = this.handleLazyAutoplay.bind(this);
      this.delegateElement.on('loadeddata', '.html5-video__video', this.handleLazyAutoplayBound);
    }
  }

  handleLazyAutoplay(event, trigger) {
    this.delegateElement.off('loadeddata', '.html5-video__video', this.handleLazyAutoplayBound);
    const playPromise = this.videoElement.play();
    if (playPromise && typeof playPromise.then === 'function') playPromise.catch(() => {});
  }

  syncStateFromVideo() {
    if (!this.videoElement) return;
    this.element.dataset.videoState = this.videoElement.paused ? 'paused' : 'playing';
    this.element.dataset.muted = this.videoElement.muted ? 'true' : 'false';
  }

  handleTogglePlay(event, trigger) {
    if (!this.videoElement) return;

    event.preventDefault();

    if (this.videoElement.paused) {
      this.element.dataset.videoState = 'playing';
      const playPromise = this.videoElement.play();
      if (playPromise && typeof playPromise.then === 'function') playPromise.catch(() => {});
    } else {
      this.videoElement.pause();
      this.element.dataset.videoState = 'paused';
    }
  }

  handleToggleMute(event, trigger) {
    if (!this.videoElement) return;

    event.preventDefault();

    this.videoElement.muted = !this.videoElement.muted;
  }
}
customElements.define('html5-video-player', Html5VideoPlayer);
